import React ,{useEffect , useState} from 'react'
import {Link} from "react-router-dom"
// import OwlCarousel from 'react-owl-carousel';  
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";


// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";


// import client1 from '../assets/images/client (1).jpg';
// import client2 from '../assets/images/client (2).jpg';
// import client3 from '../assets/images/client (3).jpg';
// import client4 from '../assets/images/client (4).jpg';
// import client5 from '../assets/images/client (5).jpg';
// import client6 from '../assets/images/client (6).jpg';
// import client7 from '../assets/images/client (7).jpg';

import C1 from "../assets/images/c1jpg.jpg";
import C2 from "../assets/images/c2_jpg.jpg";
import C3 from "../assets/images/c3_jpg.jpg";
import MinistryCertificate from "../assets/images/Ministry of Climate change and Environment.jpg";


// import port1 from '../assets/images/port (1).jpg';
// import port2 from '../assets/images/port (2).jpg';
// import port3 from '../assets/images/port (3).jpg';
// import port4 from '../assets/images/port (4).jpg';
// import port5 from '../assets/images/port (5).jpg';
// import port6 from '../assets/images/port (6).jpg';
// import port7 from '../assets/images/port (7).jpg';



// import porj1 from '../assets/images/proj (1).jpg';
// import porj2 from '../assets/images/proj (2).jpg';
// import porj3 from '../assets/images/proj (3).jpg';
// import porj4 from '../assets/images/proj (4).jpg';
// import porj5 from '../assets/images/proj (5).jpg';
// import porj6 from '../assets/images/proj (6).jpg';
// import porj7 from '../assets/images/proj (7).jpg';



// import porj1 from '../assets/images/q1.jpg';
// import porj2 from '../assets/images/q2.jpg';
// import porj3 from '../assets/images/q3.jpg';
// import porj4 from '../assets/images/q4.jpg';
// import porj5 from '../assets/images/q5.jpg';
// import porj6 from '../assets/images/q6.jpg';
// import porj7 from '../assets/images/q7.jpg';









import alBarari01 from "../assets/images/Al Barari/Al Barari 01.jpeg";
import alBarari02 from "../assets/images/Al Barari/Al Barari 02.jpeg";
import alBarari03 from "../assets/images/Al Barari/Al Barari 03.jpeg";
import alBarari04 from "../assets/images/Al Barari/Al Barari 04.jpeg";
import alBarari05 from "../assets/images/Al Barari/Al Barari 05.jpeg";
import alBarari06 from "../assets/images/Al Barari/Al Barari 06.jpeg";

import alBarsha01 from "../assets/images/Al Barsha South-Dubai/01.jpeg";
import alBarsha02 from "../assets/images/Al Barsha South-Dubai/02.jpeg";
import alBarsha03 from "../assets/images/Al Barsha South-Dubai/03.jpeg";

import alMarwan08 from "../assets/images/Al Marwan Group/08.jpeg";
import alMarwan09 from "../assets/images/Al Marwan Group/09.jpeg";
import alMarwan10 from "../assets/images/Al Marwan Group/10.jpeg";
import alMarwan11 from "../assets/images/Al Marwan Group/Al marwan 11.jpeg";
import alMarwan12 from "../assets/images/Al Marwan Group/Al marwan 12.jpeg";
import alMarwan13 from "../assets/images/Al Marwan Group/Al marwan 13.jpeg";
import alMarwan14 from "../assets/images/Al Marwan Group/Al marwan 14.jpeg";
import alMarwan15 from "../assets/images/Al Marwan Group/Al marwan 15.jpeg";

import alTaween01 from "../assets/images/Al Taween Mountain-200 date palms plantation/Al taween Mountain 1.jpeg";
import alTaween02 from "../assets/images/Al Taween Mountain-200 date palms plantation/Al taween mountain 02.jpeg";
import alTaween03 from "../assets/images/Al Taween Mountain-200 date palms plantation/Al taween mountain 03.jpeg";
import alTaween04 from "../assets/images/Al Taween Mountain-200 date palms plantation/Al taween mountain 04.jpeg";

import dubaiHills01 from "../assets/images/Dubai Hills villa/Dubai hills villa 01.jpeg";
import dubaiHills02 from "../assets/images/Dubai Hills villa/Dubai hills villa 02.jpeg";
import dubaiHills03 from "../assets/images/Dubai Hills villa/Dubai Hills villa 03.jpeg";
import dubaiHills04 from "../assets/images/Dubai Hills villa/Dubai hills villa 04.jpeg";
import dubaiHills05 from "../assets/images/Dubai Hills villa/Dubai hills villa 05.jpeg";

import theVilla01 from "../assets/images/Dubai land-The Villa/The villa 01.jpeg";
import theVilla02 from "../assets/images/Dubai land-The Villa/The villa 02.jpeg";
import theVilla03 from "../assets/images/Dubai land-The Villa/The villa 03.jpeg";
import theVilla04 from "../assets/images/Dubai land-The Villa/The villa 04.jpeg";
import theVilla05 from "../assets/images/Dubai land-The Villa/The villa 05.jpeg";

import grass01 from "../assets/images/Grass plantation-Dubai/Grass plantation 1.jpeg";
import grass02 from "../assets/images/Grass plantation-Dubai/Grass plantation 2.jpeg";
import grass03 from "../assets/images/Grass plantation-Dubai/Grass plantation 3.jpeg";
import grass04 from "../assets/images/Grass plantation-Dubai/Grass plantation 4.jpeg";
import grass05 from "../assets/images/Grass plantation-Dubai/Grass plantation 5.jpeg";
import grass06 from "../assets/images/Grass plantation-Dubai/Grass plantation 6.jpeg";
import grass07 from "../assets/images/Grass plantation-Dubai/Grass plantation 7.jpeg";
import grass08 from "../assets/images/Grass plantation-Dubai/Grass plantation 8.jpeg";

import hyde01 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 2-01.jpeg";
import hyde02 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 4-01.jpeg";
import hyde03 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 5-02.jpeg";
import hyde04 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 6 (1)-01.jpeg";
import hyde05 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 7-01.jpeg";
import hyde06 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 8-01.jpeg";
import hyde07 from "../assets/images/Hyde Walk By Imtiaz-Artificial palm plantation/Hyde walk- By Imtiaz 9-01.jpeg";

import imtiaz01 from "../assets/images/Imtiaz developments/Imtiaz development 01.jpeg";
import imtiaz02 from "../assets/images/Imtiaz developments/Imtiaz development 02.jpeg";
import imtiaz03 from "../assets/images/Imtiaz developments/Imtiaz development 03.jpeg";
import imtiaz04 from "../assets/images/Imtiaz developments/Imtiaz development 04.jpeg";

import jumeirah01 from "../assets/images/Jumeirah Golf Estate-Decking work/Jumeirah golf 01.jpeg";
import jumeirah02 from "../assets/images/Jumeirah Golf Estate-Decking work/Jumeirah golf 02.jpeg";
import jumeirah03 from "../assets/images/Jumeirah Golf Estate-Decking work/Jumeirah golf 03.jpeg";

import springfield01 from "../assets/images/Spring field properties- Olive tree plantation/01.jpeg";
import springfield02 from "../assets/images/Spring field properties- Olive tree plantation/02.jpeg";
import springfield03 from "../assets/images/Spring field properties- Olive tree plantation/03.jpeg";

import springs01 from "../assets/images/Springs -Private villa/Springs private villa 01.jpeg";
import springs02 from "../assets/images/Springs -Private villa/Springs-Private villa 02.jpeg";
import springs03 from "../assets/images/Springs -Private villa/Springs-Private villa 03.jpeg";
import springs04 from "../assets/images/Springs -Private villa/Springs-Private villa 04.jpeg";
import springs05 from "../assets/images/Springs -Private villa/Springs private villa 05.jpeg";

import tilal01 from "../assets/images/Tilal Al Ghaf/T1.jpeg";
import tilal02 from "../assets/images/Tilal Al Ghaf/T2.jpeg";
import tilal03 from "../assets/images/Tilal Al Ghaf/T3.jpeg";



import swal from 'sweetalert';
// import Loader from "react-loader-spinner";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { Container, Card, Row, Col } from "react-bootstrap";
// import FavoriteIcon from '@material-ui/icons/Favorite';

import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";


// import slid2 from '../assets/images/slid2.webp';


// import ch1 from '../asset1/images/demos/demo-26/banners/banner-5.jpg';
// import ch2 from '../asset1/images/demos/demo-26/banners/banner-6.jpg';
// import ch3 from '../asset1/images/demos/demo-26/bg-1.jpg';

// import slid1 from '../assets/images/slider (1).png';
// import slid2 from '../assets/images/slider (2).png';
// import slid3 from '../assets/images/slider (3).png';
// import slid4 from '../assets/images/slider (4).png';
// import slid5 from '../assets/images/slider (5).jpg';
// import slid6 from '../assets/images/slider6.jpg';




// import ch4 from '../asset1/images/demos/demo-14/slider/slide-2.jpg';
// import ch5 from '../asset1/images/demos/demo-26/banners/banner-3.jpg';
// import ch6 from '../asset1/images/demos/demo-26/banners/banner-4.jpg';
// import Carousel1 from './Carosel';
// import Carousel2 from './Carosel1';
// import Carousel3 from './Carosel2';
// import Carousel4 from './Carosel3';
// import Carousel5 from './Carosel4';
// import Carousel6 from './Carosel5';
// import Carousel7 from './Carosel6';
// import Carousel8 from './Carosel7';
// import Ico from './iconBox';
// import Cate from './Cate';

// import "react-multi-carousel/lib/styles.css";

import FeaturedServices from "./FeaturedServices";


import ClientProjects from "./client";


// const responsive = {
//     superLargeDesktop: {
//         breakpoint: { max: 4000, min: 3000 },
//         items: 5,
//     },
//     desktop: {
//         breakpoint: { max: 3000, min: 1024 },
//         items: 5,
//     },
//     tablet: {
//         breakpoint: { max: 1024, min: 464 },
//         items: 2,
//     },
//     mobile: {
//         breakpoint: { max: 464, min: 0 },
//         items: 1,
//     },
// };






const Home = ( props ) => {
  //   const  responsive= {
  //     0: {
  //         items: 1,
  //     },
  //     450: {
  //         items: 2,
  //     },
  //     600: {
  //         items: 3,
  //     },
  //     1000: {
  //         items: 4,
  //     },
  // }
  //   const  responsive1= {
  //     0: {
  //         items: 2,
  //     },
  //     450: {
  //         items: 2,
  //     },
  //     600: {
  //         items: 3,
  //     },
  //     750: {
  //         items: 4,
  //     },
  //     1000: {
  //         items: 7,
  //     },
  // }
  //   const  responsive2= {
  //     0: {
  //         items: 2,
  //     },
     
  //     450: {
  //         items: 3,
  //     },
  //     600: {
  //         items: 4,
  //     },
  //     1000: {
  //         items: 6,
  //     },
  // }
  // const settings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1
  // };
  const options = {
    // margin: 30,
    // responsiveClass: true,
    // nav: true,
    // dots: false,
    // autoplay: false,
    // navText: ["Prev", "Next"],
    // smartSpeed: 1000,
    responsive: {
        0: {
            items: 1,
        },
        400: {
            items: 1,
        },
        600: {
            items: 2,
        },
        700: {
            items: 4,
        },
        1600: {
            items: 4,

        }
    },
};
//     const [options , setoptions] = useState( {
//     loop: true,
//     margin: 10,
//     nav: true,
//     responsive: {
//         0: {
//             items: 1,
//         },
//         600: {
//             items: 3,
//         },
//         1000: {
//             items: 4,
//         },
//     },
// })
    // const [Categories , setCategories] = useState([])
    // const [Categories1 , setCategories1] = useState([])
    // const [Homo , setHomo] = useState([])
    const [product , setproduct] = useState([])
    const [dis , setdis] = useState(false)

    const [product1 , setproduct1] = useState([])
    const [product8 , setproduct8] = useState([])
    const [product9 , setproduct9] = useState([])
    const [product10 , setproduct10] = useState([])
    const [product11 , setproduct11] = useState([])
    // const [UserDatat , setUserDatat] = useState({})
    // const [userHeader , setuserHeader] = useState(false)
    const [SliderPhoto , setSliderPhoto] = useState([])
    // const [ArrivalPhoto , setArrivalPhoto] = useState([])
    // const [BannerPhoto , setBannerPhoto] = useState([])
    const [MainCatogories , setMainCatogories] = useState([])
    const [SubCategories , setSubCategories] = useState([])
    // const [SubClassCategories , setSubClassCategories] = useState([])
    const [SubClassCategories1 , setSubClassCategories1] = useState([])
    const [SubClassCategories2 , setSubClassCategories2] = useState([])
    const [DataPart2 , setDataPart2] = useState([])
    // const [fvalue , setfvalue] = useState([])
    // const [data, setdata] = useState([]) 
    // const [companieswith , setcompanieswith] = useState([])
    // const [couponShow , setcouponShow] = useState(true)
    // const [chk1 , setchk1] = useState(true)
    // const [chk2 , setchk2] = useState(true)
    const [Cate1 , setCate1] = useState([])
    // const [Cate2 , setCate2] = useState([])

    // const [Ite1 , setIte1] = useState(1)
    // const [Ite2 , setIte2] = useState(1)


const [selectedProject, setSelectedProject] = useState(null);
const [currentImage, setCurrentImage] = useState(0);


      const [selectedCertificate, setSelectedCertificate] = useState(null);


      const projects = [
  {
    title: "Al Barari",
    category: "Landscape Project",
    images: [
      alBarari01,
      alBarari02,
      alBarari03,
      alBarari04,
      alBarari05,
      alBarari06,
    ],
  },

  {
    title: "Al Barsha South - Dubai",
    category: "Landscape Project",
    images: [
      alBarsha01,
      alBarsha02,
      alBarsha03,
    ],
  },

  {
    title: "Al Marwan Group",
    category: "Landscape Project",
    images: [
      alMarwan08,
      alMarwan09,
      alMarwan10,
      alMarwan11,
      alMarwan12,
      alMarwan13,
      alMarwan14,
      alMarwan15,
    ],
  },

  {
    title: "Al Taween Mountain",
    category: "200 Date Palms Plantation",
    images: [
      alTaween01,
      alTaween02,
      alTaween03,
      alTaween04,
    ],
  },

  {
    title: "Dubai Hills Villa",
    category: "Villa Landscape",
    images: [
      dubaiHills01,
      dubaiHills02,
      dubaiHills03,
      dubaiHills04,
      dubaiHills05,
    ],
  },

  {
    title: "Dubai Land - The Villa",
    category: "Villa Landscape",
    images: [
      theVilla01,
      theVilla02,
      theVilla03,
      theVilla04,
      theVilla05,
    ],
  },

  {
    title: "Grass Plantation - Dubai",
    category: "Plantation Project",
    images: [
      grass01,
      grass02,
      grass03,
      grass04,
      grass05,
      grass06,
      grass07,
      grass08,
    ],
  },

  {
    title: "Hyde Walk By Imtiaz",
    category: "Artificial Palm Plantation",
    images: [
      hyde01,
      hyde02,
      hyde03,
      hyde04,
      hyde05,
      hyde06,
      hyde07,
    ],
  },

  {
    title: "Imtiaz Developments",
    category: "Landscape Project",
    images: [
      imtiaz01,
      imtiaz02,
      imtiaz03,
      imtiaz04,
    ],
  },

  {
    title: "Jumeirah Golf Estate",
    category: "Decking Work",
    images: [
      jumeirah01,
      jumeirah02,
      jumeirah03,
    ],
  },

  {
    title: "Springfield Properties",
    category: "Olive Tree Plantation",
    images: [
      springfield01,
      springfield02,
      springfield03,
    ],
  },

  {
    title: "Springs - Private Villa",
    category: "Private Villa",
    images: [
      springs01,
      springs02,
      springs03,
      springs04,
      springs05,
    ],
  },

  {
    title: "Tilal Al Ghaf",
    category: "Landscape Project",
    images: [
      tilal01,
      tilal02,
      tilal03,
    ],
  },
];


        const certificates = [
    {
      id: 1,
      image: C1,
      title: "Certificate of Excellence",
    },
    {
      id: 2,
      image: C2,
      title: "Professional Certificate",
    },
    {
      id: 3,
      image: C3,
      title: "Business Certificate",
    },
    {
      id: 4,
      image: MinistryCertificate,
      title: "Ministry of Climate Change and Environment",
    },
  ];

    const [fg , setfg] = useState(true)
    // var settings = {
    //   infinite: true,
    //   dots: true,
    //   slidesToShow: 5,
    //   slidesToScroll: 1,
    //   lazyLoad: true,
    //   autoplay: true,
    // autoplaySpeed: 2000,
    // };
    useEffect(() =>{

        window.scrollTo(0, 0)
        setInterval(() => {
          if( document.getElementsByClassName("carousel-indicators")[0])
          document.getElementsByClassName("carousel-indicators")[0].remove()
        }, 1000);
        
      // document.getElementsByClassName("carousel-indicators")
      // document.getElementsByClassName("visually-hidden")[0].remove()
      // document.getElementsByClassName("visually-hidden")[0].remove()
      // document.getElementsByClassName("visually-hidden")[1].remove()
      console.log(    document.getElementsByClassName("carousel-indicators")[0]
      )
        fetch("https://garden-oasis-landscapping-main-back.vercel.app/slider-photo",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res=>res.json())
        .then(res1=>{
            console.log(res1[0]);
            setSliderPhoto(res1)
          })
      
        fetch("https://garden-oasis-landscapping-main-back.vercel.app/MainCatogories",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res2=>res2.json())
        .then(res3=>{
            console.log(res3);
            // setMainCatogories(res3)
            

            let dat = []
            res3.map((res55,c)=>{
                dat.push(res55)
            })
            // console.log(SubClassCategories,asse)
            console.log(dat)
            let data = dat.sort((a, b) => {
                return a.sort - b.sort;
            });
            setMainCatogories(data)
            
        })
        fetch("https://garden-oasis-landscapping-main-back.vercel.app/AllCategories",{
          method: "GET",
           headers :  {
           "Content-Type" : "application/json" , 
       } ,
      })
      .then(res2=>res2.json())
      .then(res3=>{
        let unique_values = res3
        .map((item) => item.CategoriesName)
        .filter(
            (value, index, current_value) => current_value.indexOf(value) === index
        );
          // console.log(res3);
          // const Data1 = res3.filter((res4,i)=>{
          //     if (res4.MainCategories === props.history.location.pathname.split("/")[2])
          //     return res4
          // })
          // console.log(Data1,res3)
          setSubCategories(unique_values)
          // setSubCategoriesname(res3)
          fetch("https://garden-oasis-landscapping-main-back.vercel.app/MainCatogories",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res12=>res12.json())
        .then(res13=>{
          let a = []
          console.log(res13)
          for (let i = 0; i < res13.length; i++) {
          for (let j = 0; j < res3.length; j++) {
            // console.log(res3[j].MainCategories , res13[i].MainCategories)
            if(res3[j].MainCategories === res13[i].MainCategories){
              // a.push("1")
// console.log(i,j)
              a[i] = "1"
              break
            }
            else{
              a[i] = "0"
              // a.pusH(("0"))
            }
            
          }
          }
          // console.log(a)
          setCate1(a)
        })
      })




        localStorage.removeItem("SearchData")
        localStorage.removeItem("Data")
        localStorage.removeItem("CartPrice")
        localStorage.removeItem("CateProduct")

        // if ( JSON.parse(localStorage.getItem("User"))  ){
        //     setuserHeader(true)
        //     setUserDatat(JSON.parse(localStorage.getItem("User")))
        //     const cartUser1 = JSON.parse(localStorage.getItem("Cart"))
        //     if (cartUser1 ){
        // fetch("https://garden-oasis-landscapping-main-back.vercel.app/user-cart-add",{
        //                         method: "POST",
        //                         headers :  {
        //                             "Content-Type" : "application/json" , 
        //                         } ,
        //                         body : JSON.stringify({
        //                             cart : cartUser1 ,
        //                             user : JSON.parse(localStorage.getItem("User")) 
        //                         })
        //                     })
        //                     .then(res=>res.json())
        //                     .then((res1)=>{ 
        //                         console.log(res1);
        //                     })

        //     }
        // }
        var data1 =  JSON.parse(localStorage.getItem("Cart")) 
      //   fetch("https://garden-oasis-landscapping-main-back.vercel.app/FAQ1",{
      //     method: "GET",
      //      headers :  {
      //      "Content-Type" : "application/json" , 
      //  } ,
      // })
      // .then(res3=>res3.json())
      // .then(res4=>{
      //   let dat1 = []
      //   res4.map((res55,c)=>{
      //       dat1.push(0)
      //   })
      //   setfvalue(dat1)
      //        setdata(res4)
      //        data.map((res,i)=>{
      //         data1[i] = res.text
      //        })

      //     console.log(res4)
      //   })
        fetch("https://garden-oasis-landscapping-main-back.vercel.app/AllProduct",{
       method: "GET",
        headers :  {
        "Content-Type" : "application/json" , 
    }
   })
   .then(res5=>res5.json())
   .then(res6=>{
    localStorage.setItem("Prod",JSON.stringify(res6))
    //    console.log(res6);
    const pro = []
    const pro1 = []
    const pro2 = []
    const pro3 = []
    res6.map((res7,i)=>{
        //    console.log(res7.Product_Popular );
        if ( res7.Arrival){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro.push(res7)
        }
        if ( res7.Arrival1){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro1.push(res7)
        }
        if ( res7.Arrival2){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro2.push(res7)
        }
        if ( res7.Arrival3){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro3.push(res7)
        }
    })
    // setproduct(pro.reverse())
    setproduct8(pro)
    setproduct9(pro1)
    setproduct10(pro2)
    setproduct11(pro3)
    setproduct(pro.slice(0,8))
    setproduct1(pro1.slice(0,8))
    // setproduct1(pro1.slice(0,7))
    // setproduct1(pro1)
    setdis(true)
   })
    
//     fetch("/AllCategories",{
//        method: "GET",
//         headers :  {
//         "Content-Type" : "application/json" , 
//     } ,
//    })
//    .then(res=>res.json())
//    .then(res1=>{
//     setCategories(res1)
   
//    })

    
//     fetch("/AllHomomethtic",{
//        method: "GET",
//         headers :  {
//         "Content-Type" : "application/json" , 
//     } ,
//    })
//    .then(res3=>res3.json())
//    .then(res4=>{
//     setHomo(res4)
//     // console.log(res4);
//    })

 },[])

 const savethedetailproduct = (data) =>{
    localStorage.setItem("Data" , JSON.stringify(data) )
    console.log(data);
 }
 
 
 const cate =(Categories) =>{
     var Cat1 = Categories.split(" ").join("-")
     
     localStorage.setItem("Cate" , JSON.stringify(Categories) )
     
     setTimeout(()=>{
            props.history.push(`/shop/categories/AED {Cat1}`)
        },1500)
    }
    
    
    
    const carrouselAutoChange=()  =>{
      carrouselRight();
    }
    
    
    
    const carrouselChange=(i) => {
    
      var carrousel = document.getElementById("carrouselimg" + i);
      carrousel.style.opacity = "1";
    
    }
    
    
    const carrouselLeft=()  =>{
    
      let nbCarrousel = 4;
      let num = 0;
    
      for (let i = 0; i < nbCarrousel; i++) {
          num = i + 1;
          var carrousel = document.getElementById("carrouselimg" + num);
          if (carrousel.style.opacity == "1") {
              carrousel.style.opacity = "0";
              if (i == 0) {
                  return carrouselChange(4);
              }
              return carrouselChange(num - 1);
          }
      }
    }
    
    const carrouselRight=() =>{
    
      let nbCarrousel = 4;
      let num = 0;
    
      for (let i = 0; i < nbCarrousel; i++) {
          num = i + 1;
          var carrousel = document.getElementById("carrouselimg" + num);
          if (carrousel.style.opacity == "1") {
              carrousel.style.opacity = "0";
              if (i == 3) {
                  return carrouselChange(1);
              }
              return carrouselChange(num + 1);
          }
      }
    }
    
    
    

    
        return (
            
          <div>
          <div className="page-wrapper">
            



             {/* <div
              className="intro-slide bg-image d-flex align-items-center change-slid1"
              style={{ height: "320px" }}
              onClick={() =>
                props.history.push("categories-main/Annual Maintenance Contract")
              }
            >
              <img
                src={slid3}
                alt=""
                className="change-slid"
                style={{ height: "485px" }}
              />
            </div>

            <div
              className="intro-slide bg-image d-flex align-items-center change-slid1"
              style={{ height: "320px" }}
              onClick={() =>
                props.history.push("categories-main/Landscaping")
              }
            >
              <img
                src={slid2}
                alt=""
                className="change-slid"
                style={{ height: "485px" }}
              />
            </div>

            <div
              className="intro-slide bg-image d-flex align-items-center change-slid1"
              style={{ height: "320px" }}
              onClick={() =>
                props.history.push(
                  "categories-main/Landscaping"
                )
              }
            >
              <img
                src={slid4}
                alt=""
                className="change-slid"
                style={{ height: "485px" }}
              />
            </div>

            <div
              className="intro-slide bg-image d-flex align-items-center change-slid1"
              style={{ height: "320px" }}
              onClick={() =>
                props.history.push(
                  "categories-main/Landscaping"
                )
              }
            >
              <img
                src={slid1}
                alt=""
                className="change-slid"
                style={{ height: "485px" }}
              />
            </div> */}


            


            {/* End .header */}
            <main className="main">
              <div className="intro-section change-height-slider">
  <div className="container">
    <div className="row">
      <div className="col-xl-12 col-md-12 col-12 mb-md-0">
        <div className="intro-slider-container modern-hero-slider">




<Carousel
  autoPlay={true}
  interval={4000}
  showThumbs={false}
  showArrows={true}
  showStatus={false}
  swipeable={true}
  infiniteLoop={true}
  style={{ height: "800px" }}
>

  {/* =========================
      SLIDE 1
  ========================== */}
  <div className="hero-slide">

    <img
      src="https://ranaalkassim.com/wp-content/uploads/2024/11/landscape_feature-img1.webp"
      alt="Landscaping Services Dubai"
      className="hero-slide-image"
    />

    <div className="hero-overlay"></div>

    <div className="hero-content">

      <span className="hero-small-title">
        GARDEN OASIS LANDSCAPING
      </span>

      <h1>
        Transform Your Outdoor Space
      </h1>

      <p>
        Professional landscaping services designed to create
        beautiful, relaxing and vibrant outdoor spaces in Dubai.
      </p>

      <Link
        to="/best-landscaping-service-dubai"
        className="hero-button"
      >
        Explore Landscaping
        <span>→</span>
      </Link>

    </div>

  </div>


  {/* =========================
      SLIDE 2
  ========================== */}
  <div className="hero-slide">

    <img
      src="https://smartrenovation.ae/wp-content/uploads/2025/08/Smart-Renovation-Landscaping-2.jpg"
      alt="Garden Landscaping Dubai"
      className="hero-slide-image"
    />

    <div className="hero-overlay"></div>

    <div className="hero-content">

      <span className="hero-small-title">
        BEAUTIFUL GARDENS
      </span>

      <h1>
        Create Your Dream Garden
      </h1>

      <p>
        From garden design to complete landscaping,
        we bring your outdoor vision to life.
      </p>

      <Link
        to="/best-landscaping-service-dubai"
        className="hero-button"
      >
        Discover Our Services
        <span>→</span>
      </Link>

    </div>

  </div>


  {/* =========================
      SLIDE 3
  ========================== */}
  <div className="hero-slide">

    <img
      src="https://smartrenovation.ae/wp-content/uploads/2025/08/Smart-Renovation-Landscaping-5.jpg"
      alt="Garden Maintenance Dubai"
      className="hero-slide-image"
    />

    <div className="hero-overlay"></div>

    <div className="hero-content">

      <span className="hero-small-title">
        EXPERT GARDEN CARE
      </span>

      <h1>
        Keep Your Garden Fresh & Beautiful
      </h1>

      <p>
        Reliable garden maintenance solutions to keep your
        landscape healthy, green and beautiful all year round.
      </p>

      <Link
        to="/garden-maintenance-services-dubai"
        className="hero-button"
      >
        Garden Maintenance
        <span>→</span>
      </Link>

    </div>

  </div>


  {/* =========================
      SLIDE 4
  ========================== */}
  <div className="hero-slide">

    <img
      src="https://smartrenovation.ae/wp-content/uploads/2025/08/Smart-Renovation-Landscaping-8.jpg"
      alt="Landscaping Company Dubai"
      className="hero-slide-image"
    />

    <div className="hero-overlay"></div>

    <div className="hero-content">

      <span className="hero-small-title">
        GARDEN OASIS LANDSCAPING
      </span>

      <h1>
        Professional Landscaping in Dubai
      </h1>

      <p>
        Quality landscaping, garden maintenance and outdoor
        solutions for homes and businesses across Dubai.
      </p>

      <Link
        to="/best-landscaping-service-dubai"
        className="hero-button"
      >
        Get Started
        <span>→</span>
      </Link>

    </div>

  </div>

</Carousel>




          {/* <Carousel
            autoPlay={true}
            interval={4000}
            showThumbs={false}
            showArrows={true}
            showStatus={false}
            swipeable={true}
            swipeAble={true}
            infiniteLoop={true}
            style={{ height: "300px" }}
          >

           


            <div
              className="intro-slide bg-image d-flex align-items-center change-slid1"
              style={{ height: "800px" }}
              onClick={() =>
                props.history.push("categories-main/Landscaping")
              }
            >
              <img
                src={"https://ranaalkassim.com/wp-content/uploads/2024/11/landscape_feature-img1.webp"}
                alt=""
                className="change-slid"
                style={{ height: "800px" }}
              />
            </div>

            <div
              className="intro-slide bg-image d-flex align-items-center change-slid1"
              style={{ height: "800px" }}
              onClick={() =>
                props.history.push(
                  "categories-main/Landscaping"
                )
              }
            >
              <img
                src={"https://smartrenovation.ae/wp-content/uploads/2025/08/Smart-Renovation-Landscaping-2.jpg"}
                alt=""
                className="change-slid"
                style={{ height: "800px" }}
              />
            </div>

            <div
              className="intro-slide bg-image d-flex align-items-center change-slid1"
              style={{ height: "800px" }}
              onClick={() =>
                props.history.push(
                  "categories-main/Landscaping"
                )
              }
            >
              <img
                src={"https://smartrenovation.ae/wp-content/uploads/2025/08/Smart-Renovation-Landscaping-5.jpg"}
                alt=""
                className="change-slid"
                style={{ height: "800px" }}
              />
            </div>
            <div
              className="intro-slide bg-image d-flex align-items-center change-slid1"
              style={{ height: "800px" }}
              onClick={() =>
                props.history.push(
                  "categories-main/Landscaping"
                )
              }
            >
              <img
                src={"https://smartrenovation.ae/wp-content/uploads/2025/08/Smart-Renovation-Landscaping-8.jpg"}
                alt=""
                className="change-slid"
                style={{ height: "800px" }}
              />
            </div>
                 

          </Carousel> */}

        </div>
      </div>
    </div>
  </div>
</div>

             


       {/* <div
              className="intro-slide bg-image d-flex align-items-center change-slid1"
              style={{ height: "800px" }}
              onClick={() =>
                props.history.push("categories-main/Annual Maintenance Contract")
              }
            >
              <img
                src={"https://images.squarespace-cdn.com/content/v1/5f7e76bb224d930297423ea8/b3d0b8aa-ec71-48fd-bf29-48d7403a018e/MDO-Palm-Hills-67-286.jpg?format=2500w"}
                alt=""
                className="change-slid"
                style={{ height: "800px" }}
              />
            </div> */}














<FeaturedServices />















<section className="go-categories">
  <div className="container">

    <div className="go-head text-center">
      <span className="sub-title">EXPLORE OUR SERVICES</span>
      <h2>Top Plant & Gardening Categories</h2>
      <div className="go-line"></div>
    </div>

    <div className="row">
      {[
        {
          icon: "fa-cogs",
          title: "Annual Maintenance Contract",
          desc: "Complete yearly garden and landscape maintenance services for residential and commercial properties."
        },

        {
          icon: "fa-leaf",
          title: "Landscaping Services",
          desc: "Professional landscaping solutions with modern designs suitable for Dubai climate conditions."
        },
        {
          icon: "fa-home",
          title: "Villa Landscape Maintenance",
          desc: "Premium villa landscaping and maintenance services to enhance outdoor living spaces."
        },
        {
          icon: "fa-water",
          title: "Swimming Pool Maintenance",
          desc: "Professional swimming pool cleaning, chemical balancing and complete maintenance solutions."
        },
        {
          icon: "fa-seedling",
          title: "Garden Maintenance",
          desc: "Regular garden care including trimming, cleaning, fertilizing and plant health management."
        },
        {
          icon: "fa-tree",
          title: "Outdoor Plants",
          desc: "Wide range of outdoor plants selected specially to thrive in UAE weather conditions."
        },
        {
          icon: "fa-store",
          title: "Wholesale Plant Shop",
          desc: "Bulk supply of indoor and outdoor plants at competitive wholesale market prices."
        },
        {
          icon: "fa-building",
          title: "Commercial Landscaping",
          desc: "Landscaping and maintenance services for offices, hotels, malls and commercial projects."
        },
        {
          icon: "fa-bug",
          title: "Pest Control Services",
          desc: "Safe and effective pest control solutions to protect your garden and outdoor areas."
        },
        {
          icon: "fa-tools",
          title: "Premium Gardening Tools",
          desc: "High-quality gardening tools and equipment for professional and home garden use."
        },
        {
          icon: "fa-leaf",
          title: "Home Garden Maintenance",
          desc: "Complete home garden maintenance ensuring healthy plants and beautiful outdoor spaces."
        }
      ].map((item, index) => (
        <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
          <div className="go-card">

            <div className="go-icon">
              <i className={`fas ${item.icon}`}></i>
            </div>

            <h5>{item.title}</h5>
            <p>{item.desc}</p>

            <a
              href={`https://wa.me/971509480695?text=Hello, I am interested in ${item.title}`}
              target="_blank"
              rel="noopener noreferrer"
              className="go-btn"
            >
              {/* <i className="fab fa-whatsapp"></i> */}
               Contact Now
            </a>

          </div>
        </div>
      ))}
    </div>

  </div>
</section>





<section className="why-choose">
  <div className="container text-center">

    <h2 className="wc-title">
      Creating Beautiful, Healthy & Sustainable Outdoor Spaces
    </h2>

    <div className="row wc-row">

      <div className="wc-card">
        <br />
        <i className="fas fa-leaf"></i>

        <h4>Expert Landscaping</h4>

        <p>
          Our skilled team creates beautiful and functional landscapes with
          thoughtful garden design, quality plants, and professional
          workmanship.
        </p>

        <a href="/best-landscaping-service-dubai" className="wc-btn">
          EXPLORE SERVICES
        </a>
      </div>


      <div className="wc-card">

        <i className="fas fa-seedling"></i>

        <h4>Complete Garden Care</h4>

        <p>
          From regular garden maintenance and planting to irrigation and
          seasonal care, we keep your outdoor spaces fresh, healthy, and
          beautiful throughout the year.
        </p>

        <a
          href="/garden-maintenance-services-dubai"
          className="wc-btn"
        >
          GARDEN SERVICES
        </a>

      </div>


      <div className="wc-card">

        <i className="fas fa-tools"></i>

        <h4>Quality & Reliability</h4>

        <p>
          We deliver dependable landscaping solutions with attention to detail,
          professional service, and a commitment to maintaining high standards
          on every project.
        </p>

        <a href="/contact" className="wc-btn">
          CONTACT US
        </a>

      </div>

    </div>
  </div>
</section>



<br />


{/* 
<section className="modern-projects-section">
  <div className="container">

    <h3 className="modern-projects-title">
      Our Completed Projects
    </h3>
    <span className="modern-projects-line"></span>

    <div className="modern-projects-grid">
      {[porj1, porj2, porj3, porj4, porj5, porj6].map((img, index) => (
        <div className="modern-project-card" key={index}>
          <img src={img} alt={`Project ${index + 1}`} className="modern-project-img" />
        </div>
      ))}
    </div>
  </div>
</section> */}






<section className="modern-projects-section">
  <div className="container">

    <div className="modern-projects-heading">
      <span>OUR PORTFOLIO</span>

      <h3 className="modern-projects-title">
        Our Completed Projects
      </h3>

      <span className="modern-projects-line"></span>

      <p>
        Explore our completed landscape design, plantation, decking,
        and outdoor projects across Dubai and the UAE.
      </p>
    </div>


    <div className="modern-projects-grid">

      {projects.map((project, index) => (

        <div
          className="modern-project-card"
          key={index}
          onClick={() => {
            setSelectedProject(project);
            setCurrentImage(0);
          }}
        >

          <img
            src={project.images[0]}
            alt={project.title}
            className="modern-project-img"
          />

          <div className="modern-project-overlay">

            <span>
              {project.category}
            </span>

            <h4>
              {project.title}
            </h4>

            <small>
              View Project →
            </small>

          </div>

        </div>

      ))}

    </div>

  </div>
</section>


{/* =========================
    PROJECT IMAGE SLIDER
========================= */}

{selectedProject && (

  <div
    className="project-lightbox"
    onClick={() => setSelectedProject(null)}
  >

    <div
      className="project-lightbox-content"
      onClick={(e) => e.stopPropagation()}
    >

      {/* Close */}

      <button
        className="project-close-btn"
        onClick={() => setSelectedProject(null)}
      >
        ×
      </button>


      {/* Project Title */}

      <div className="project-lightbox-title">

        <span>
          {selectedProject.category}
        </span>

        <h3>
          {selectedProject.title}
        </h3>

      </div>


      {/* Main Image */}

      <div className="project-slider">

        <button
          className="project-slider-btn project-prev"
          onClick={() =>
            setCurrentImage(
              currentImage === 0
                ? selectedProject.images.length - 1
                : currentImage - 1
            )
          }
        >
          ❮
        </button>


        <img
          src={selectedProject.images[currentImage]}
          alt={`${selectedProject.title} ${currentImage + 1}`}
          className="project-slider-main-img"
        />


        <button
          className="project-slider-btn project-next"
          onClick={() =>
            setCurrentImage(
              currentImage === selectedProject.images.length - 1
                ? 0
                : currentImage + 1
            )
          }
        >
          ❯
        </button>

      </div>


      {/* Image Counter */}

      <div className="project-image-counter">
        {currentImage + 1} / {selectedProject.images.length}
      </div>


      {/* Thumbnails */}

      <div className="project-thumbnails">

        {selectedProject.images.map((image, index) => (

          <div
            key={index}
            className={`project-thumbnail ${
              currentImage === index ? "active" : ""
            }`}
            onClick={() => setCurrentImage(index)}
          >

            <img
              src={image}
              alt={`${selectedProject.title} thumbnail ${index + 1}`}
            />

          </div>

        ))}

      </div>

    </div>

  </div>

)}









<style>
{

`
/* =========================
   PROJECT LIGHTBOX
========================= */

/* =========================================
   PREMIUM COMPLETED PROJECTS
========================================= */

.modern-projects-section {
  position: relative;
  padding: 100px 0;
  background: #f8f8f5;
}

.modern-projects-section .container {
  max-width: 1250px;
}


/* =========================================
   SECTION HEADING
========================================= */

.modern-projects-heading {
  max-width: 760px;
  margin: 0 auto 55px;
  text-align: center;
}

.modern-projects-heading > span:first-child {
  display: inline-block;
  margin-bottom: 12px;

  color: #5b7748;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
}

.modern-projects-title {
  margin: 0;

  color: #1d241c;
  font-size: 42px;
  font-weight: 700;
  line-height: 1.2;
}

.modern-projects-line {
  display: block;

  width: 55px;
  height: 2px;

  margin: 20px auto 22px;

  background: #5b7748;
}

.modern-projects-heading p {
  max-width: 680px;
  margin: 0 auto;

  color: #72776f;
  font-size: 15px;
  line-height: 1.8;
}


/* =========================================
   PROJECT GRID
========================================= */

.modern-projects-grid {
  display: grid;

  grid-template-columns: repeat(3, 1fr);

  gap: 28px;
}


/* =========================================
   PROJECT CARD
========================================= */

.modern-project-card {
  position: relative;

  height: 390px;

  overflow: hidden;

  background: #ddd;

  border-radius: 8px;

  cursor: pointer;

  box-shadow: 0 8px 25px rgba(0, 0, 0, .07);

  transition:
    transform .45s ease,
    box-shadow .45s ease;
}

.modern-project-card:hover {
  transform: translateY(-8px);

  box-shadow: 0 20px 45px rgba(0, 0, 0, .15);
}


/* =========================================
   PROJECT IMAGE
========================================= */

.modern-project-img {
  width: 100%;
  height: 100%;

  display: block;

  object-fit: cover;

  transition:
    transform .8s cubic-bezier(.2,.7,.2,1);
}

.modern-project-card:hover .modern-project-img {
  transform: scale(1.08);
}


/* =========================================
   DARK IMAGE OVERLAY
========================================= */

.modern-project-card::after {
  content: "";

  position: absolute;

  inset: 0;

  pointer-events: none;

  background:
    linear-gradient(
      to top,
      rgba(8, 12, 7, .88) 0%,
      rgba(8, 12, 7, .55) 30%,
      rgba(8, 12, 7, .08) 65%,
      rgba(8, 12, 7, 0) 100%
    );
}


/* =========================================
   PROJECT CONTENT
========================================= */

.modern-project-overlay {
  position: absolute;

  z-index: 2;

  left: 0;
  right: 0;
  bottom: 0;

  padding: 32px 30px 28px;

  color: #fff;

  transform: translateY(5px);

  transition: transform .4s ease;
}

.modern-project-card:hover
.modern-project-overlay {
  transform: translateY(0);
}


/* Category */

.modern-project-overlay span {
  display: block;

  margin-bottom: 9px;

  color: #b8d2a9;

  font-size: 10px;
  font-weight: 700;

  letter-spacing: 2.2px;

  text-transform: uppercase;
}


/* Project Name */

.modern-project-overlay h4 {
  margin: 0;

  color: #fff;

  font-size: 23px;
  font-weight: 600;

  line-height: 1.3;
}


/* Description */

.modern-project-overlay p {
  margin: 7px 0 0;

  color: rgba(255, 255, 255, .78);

  font-size: 13px;

  line-height: 1.6;
}


/* View Project */

.modern-project-overlay small {
  display: inline-flex;

  align-items: center;

  margin-top: 16px;

  color: #fff;

  font-size: 11px;
  font-weight: 600;

  letter-spacing: .5px;

  opacity: 0;

  transform: translateY(8px);

  transition:
    opacity .35s ease,
    transform .35s ease;
}

.modern-project-card:hover
.modern-project-overlay small {
  opacity: 1;

  transform: translateY(0);
}


/* =========================================
   PROJECT NUMBER
========================================= */

.modern-project-card:nth-child(1)::before,
.modern-project-card:nth-child(2)::before,
.modern-project-card:nth-child(3)::before,
.modern-project-card:nth-child(4)::before,
.modern-project-card:nth-child(5)::before,
.modern-project-card:nth-child(6)::before,
.modern-project-card:nth-child(7)::before,
.modern-project-card:nth-child(8)::before,
.modern-project-card:nth-child(9)::before,
.modern-project-card:nth-child(10)::before,
.modern-project-card:nth-child(11)::before,
.modern-project-card:nth-child(12)::before,
.modern-project-card:nth-child(13)::before {
  position: absolute;

  z-index: 3;

  top: 20px;
  right: 20px;

  color: rgba(255,255,255,.75);

  font-size: 11px;
  font-weight: 600;

  letter-spacing: 1px;
}

.modern-project-card:nth-child(1)::before {
  content: "01";
}

.modern-project-card:nth-child(2)::before {
  content: "02";
}

.modern-project-card:nth-child(3)::before {
  content: "03";
}

.modern-project-card:nth-child(4)::before {
  content: "04";
}

.modern-project-card:nth-child(5)::before {
  content: "05";
}

.modern-project-card:nth-child(6)::before {
  content: "06";
}

.modern-project-card:nth-child(7)::before {
  content: "07";
}

.modern-project-card:nth-child(8)::before {
  content: "08";
}

.modern-project-card:nth-child(9)::before {
  content: "09";
}

.modern-project-card:nth-child(10)::before {
  content: "10";
}

.modern-project-card:nth-child(11)::before {
  content: "11";
}

.modern-project-card:nth-child(12)::before {
  content: "12";
}

.modern-project-card:nth-child(13)::before {
  content: "13";
}


/* =========================================
   LIGHTBOX
========================================= */

.project-lightbox {
  position: fixed;

  inset: 0;

  z-index: 999999;

  display: flex;

  align-items: center;
  justify-content: center;

  padding: 25px;

  background: rgba(10, 13, 9, .94);

  backdrop-filter: blur(8px);

  animation: lightboxFade .3s ease;
}

@keyframes lightboxFade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}


/* =========================================
   LIGHTBOX CONTENT
========================================= */

.project-lightbox-content {
  position: relative;

  width: 100%;
  max-width: 1150px;

  padding: 28px;

  background: #171a16;

  border: 1px solid rgba(255,255,255,.08);

  border-radius: 12px;

  box-shadow: 0 30px 80px rgba(0,0,0,.5);
}


/* =========================================
   CLOSE BUTTON
========================================= */

.project-close-btn {
  position: absolute;

  z-index: 10;

  top: 18px;
  right: 18px;

  width: 42px;
  height: 42px;

  display: flex;

  align-items: center;
  justify-content: center;

  padding: 0;

  border: 1px solid rgba(255,255,255,.15);

  border-radius: 50%;

  color: #fff;

  background: rgba(255,255,255,.08);

  font-size: 27px;
  font-weight: 300;

  line-height: 1;

  cursor: pointer;

  transition: .3s;
}

.project-close-btn:hover {
  color: #fff;

  background: #5b7748;

  border-color: #5b7748;

  transform: rotate(90deg);
}


/* =========================================
   LIGHTBOX TITLE
========================================= */

.project-lightbox-title {
  padding: 0 60px 20px 2px;
}

.project-lightbox-title span {
  display: block;

  margin-bottom: 6px;

  color: #a9c59b;

  font-size: 10px;
  font-weight: 700;

  letter-spacing: 2px;

  text-transform: uppercase;
}

.project-lightbox-title h3 {
  margin: 0;

  color: #fff;

  font-size: 27px;
  font-weight: 600;
}


/* =========================================
   MAIN SLIDER
========================================= */

.project-slider {
  position: relative;

  width: 100%;
  height: 610px;

  display: flex;

  align-items: center;
  justify-content: center;

  overflow: hidden;

  background: #0d0f0c;

  border-radius: 8px;
}

.project-slider-main-img {
  width: 100%;
  height: 100%;

  display: block;

  object-fit: contain;

  animation: imageFade .3s ease;
}

@keyframes imageFade {
  from {
    opacity: .5;
  }

  to {
    opacity: 1;
  }
}


/* =========================================
   SLIDER ARROWS
========================================= */

.project-slider-btn {
  position: absolute;

  z-index: 5;

  top: 50%;

  width: 48px;
  height: 48px;

  display: flex;

  align-items: center;
  justify-content: center;

  padding: 0;

  border: 1px solid rgba(255,255,255,.2);

  border-radius: 50%;

  color: #fff;

  background: rgba(0,0,0,.55);

  font-size: 18px;

  cursor: pointer;

  transform: translateY(-50%);

  transition: .3s;
}

.project-slider-btn:hover {
  background: #5b7748;

  border-color: #5b7748;

  transform: translateY(-50%) scale(1.08);
}

.project-prev {
  left: 20px;
}

.project-next {
  right: 20px;
}


/* =========================================
   COUNTER
========================================= */

.project-image-counter {
  padding: 14px 0 12px;

  color: #aaa;

  text-align: center;

  font-size: 12px;
}


/* =========================================
   THUMBNAILS
========================================= */

.project-thumbnails {
  display: flex;

  align-items: center;

  gap: 9px;

  width: 100%;

  padding: 2px 0 4px;

  overflow-x: auto;

  scrollbar-width: thin;
}

.project-thumbnail {
  flex: 0 0 82px;

  width: 82px;
  height: 58px;

  overflow: hidden;

  border: 2px solid transparent;

  border-radius: 5px;

  opacity: .45;

  cursor: pointer;

  transition: .3s;
}

.project-thumbnail img {
  width: 100%;
  height: 100%;

  display: block;

  object-fit: cover;

  transition: .3s;
}

.project-thumbnail:hover {
  opacity: .9;
}

.project-thumbnail:hover img {
  transform: scale(1.05);
}

.project-thumbnail.active {
  border-color: #8db67b;

  opacity: 1;
}


/* =========================================
   DESKTOP HOVER DETAILS
========================================= */

@media (min-width: 992px) {

  .modern-project-card:nth-child(3n + 1) {
    transform-origin: left center;
  }

}


/* =========================================
   TABLET
========================================= */

@media (max-width: 991px) {

  .modern-projects-section {
    padding: 80px 20px;
  }

  .modern-projects-grid {
    grid-template-columns: repeat(2, 1fr);

    gap: 22px;
  }

  .modern-project-card {
    height: 350px;
  }

  .modern-project-title {
    font-size: 36px;
  }

  .project-slider {
    height: 520px;
  }

}


/* =========================================
   MOBILE
========================================= */

@media (max-width: 767px) {

  .modern-projects-section {
    padding: 65px 15px;
  }

  .modern-projects-heading {
    margin-bottom: 38px;
  }

  .modern-project-title,
  .modern-projects-title {
    font-size: 30px;
  }

  .modern-projects-heading p {
    font-size: 14px;
  }

  .modern-projects-grid {
    grid-template-columns: 1fr;

    gap: 18px;
  }

  .modern-project-card {
    height: 300px;

    border-radius: 7px;
  }

  .modern-project-overlay {
    padding: 25px 22px 22px;
  }

  .modern-project-overlay h4 {
    font-size: 20px;
  }

  .modern-project-overlay small {
    opacity: 1;

    transform: none;
  }


  /* Lightbox */

  .project-lightbox {
    padding: 8px;
  }

  .project-lightbox-content {
    padding: 15px;

    border-radius: 8px;
  }

  .project-close-btn {
    top: 10px;
    right: 10px;

    width: 38px;
    height: 38px;
  }

  .project-lightbox-title {
    padding: 3px 48px 15px 2px;
  }

  .project-lightbox-title h3 {
    font-size: 20px;
  }

  .project-slider {
    height: 390px;

    border-radius: 6px;
  }

  .project-slider-btn {
    width: 40px;
    height: 40px;

    font-size: 15px;
  }

  .project-prev {
    left: 10px;
  }

  .project-next {
    right: 10px;
  }

  .project-thumbnail {
    flex: 0 0 68px;

    width: 68px;
    height: 50px;
  }

}


/* =========================================
   SMALL MOBILE
========================================= */

@media (max-width: 400px) {

  .modern-project-card {
    height: 270px;
  }

  .modern-project-title,
  .modern-projects-title {
    font-size: 27px;
  }

  .project-slider {
    height: 330px;
  }

  .project-lightbox-content {
    padding: 10px;
  }

}
`
}
</style>





{/* import porj1 from "../assets/images/porj1.jpg";
import porj2 from "../assets/images/porj2.jpg";
import porj3 from "../assets/images/porj3.jpg";
import porj4 from "../assets/images/porj4.jpg";
import porj5 from "../assets/images/porj5.jpg";
import porj6 from "../assets/images/porj6.jpg";
import porj7 from "../assets/images/porj7.jpg";
import porj8 from "../assets/images/porj8.jpg";
import porj9 from "../assets/images/porj9.jpg";
import porj10 from "../assets/images/porj10.jpg";
import porj11 from "../assets/images/porj11.jpg";
import porj12 from "../assets/images/porj12.jpg";
import porj13 from "../assets/images/porj13.jpg"; */}








  <div className="container-fuild modern-video-section" style={{ margin: "30px auto" }}>
  <div className="row modern-video-grid">

    <div className="col-lg-4 col-sm-12 modern-video-card">
      <iframe
        width="100%"
        height="315"
        style={{ width: "100%" }}
        src="https://www.youtube.com/embed/I_swMyeB6r0?si=qllnmggPdO6P_1OK"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>

      {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/I_swMyeB6r0?si=qllnmggPdO6P_1OK" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
    </div>
    <div className="col-lg-4 col-sm-12 modern-video-card">
      <iframe
        width="100%"
        height="315"
        style={{ width: "100%" }}
        src="https://www.youtube.com/embed/vW3L4GaqsHI?si=EjwItWin_7Rst0Gc"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>


      {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/vW3L4GaqsHI?si=EjwItWin_7Rst0Gc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
    </div>

    <div className="col-lg-4 col-sm-12 modern-video-card">
      <iframe
        width="100%"
        height="315px"
        style={{ width: "100%" }}
        src="https://www.youtube.com/embed/IEkHohNtg5Q?si=CInXJU3BCVOT6Pim"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>


  </div>
</div>








            <div className="container banner-group-1 modern-category-section">

  {/* <div className="categories">
    <center>
      <h3 className="title text-center font-weight-bold mt-1 modern-section-title">
        Top Categories this Week
      </h3>
    </center>

    <div className="modern-cate-wrapper">
      <Cate />
    </div>
  </div> */}

  {/* ===== BANNER IMAGE ===== */}
  {/* <div className="container modern-middle-banner">
    <div className="row">
      <div className="col-12">
        <div className="modern-banner-box">
          <div
            className="bg-image d-flex justify-content-center modern-banner-image"
            style={{
              backgroundImage: "url(" + slid6 + ")",
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              height: "410px",
              backgroundColor: "transparent"
            }}
          ></div>
        </div>
      </div>
    </div>
  </div> */}

  {/* ===== ICON BOXES ===== */}


    {/* <div className="container icon-boxes-section modern-icon-section">
  <div className="icon-boxes-container py-4 bg-lighter mb-2 mt-2 modern-icon-box">
      <Ico />
    </div>

    <hr className="mt-2 mb-0 modern-divider" />
  </div> */}

</div>

<br />
















<ClientProjects />





<section className="certificates-section">
        <div className="certificates-container">

          {/* Heading */}
          <div className="certificates-heading">
            <span>OUR CERTIFICATES</span>

            <h2>
              Our Certifications & Achievements
            </h2>

            <p>
              We are committed to maintaining professional standards
              and delivering reliable landscaping and garden services.
            </p>
          </div>

          {/* Certificates */}
          <div className="certificates-grid">

            {certificates.map((certificate) => (
              <div
                className="certificate-card"
                key={certificate.id}
                onClick={() =>
                  setSelectedCertificate(certificate)
                }
              >

                <div className="certificate-image-box">

                  <img
                    src={certificate.image}
                    alt={certificate.title}
                  />

                  <div className="certificate-overlay">
                    <span>
                      View Certificate
                    </span>
                  </div>

                </div>

                <div className="certificate-title">
                  <h3>
                    {certificate.title}
                  </h3>
                </div>

              </div>
            ))}

          </div>
        </div>
      </section>


      {/* Certificate Popup */}

      {selectedCertificate && (
        <div
          className="certificate-modal-overlay"
          onClick={() => setSelectedCertificate(null)}
        >

          <div
            className="certificate-modal"
            onClick={(e) => e.stopPropagation()}
          >

            <button
              className="certificate-close"
              onClick={() => setSelectedCertificate(null)}
            >
              ×
            </button>

            <img
              src={selectedCertificate.image}
              alt={selectedCertificate.title}
            />

            <h3>
              {selectedCertificate.title}
            </h3>

          </div>

        </div>
      )}


      {/* CSS */}

      <style>
        {`

        /* ==============================
           SECTION
        ============================== */

        .certificates-section {
          width: 100%;
          padding: 20px 20px;
          background: #f8faf7;
        }

        .certificates-container {
          max-width: 1200px;
          margin: auto;
        }


        /* ==============================
           HEADING
        ============================== */

        .certificates-heading {
          max-width: 700px;
          margin: 0 auto 50px;
          text-align: center;
        }

        .certificates-heading span {
          display: inline-block;
          margin-bottom: 10px;

          color: #4b8b3b;

          font-size: 13px;
          font-weight: 700;

          letter-spacing: 3px;
        }

        .certificates-heading h2 {
          margin: 0 0 15px;

          color: #222;

          font-size: 42px;
          font-weight: 700;
          line-height: 1.2;
        }

        .certificates-heading p {
          margin: 0;

          color: #777;

          font-size: 15px;
          line-height: 1.7;
        }


        /* ==============================
           GRID
        ============================== */

        .certificates-grid {
          display: grid;

          grid-template-columns:
            repeat(4, 1fr);

          gap: 25px;
        }


        /* ==============================
           CARD
        ============================== */

        .certificate-card {
          background: #fff;

          border-radius: 12px;

          overflow: hidden;

          cursor: pointer;

          box-shadow:
            0 5px 20px
            rgba(0, 0, 0, 0.07);

          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
        }

        .certificate-card:hover {
          transform: translateY(-7px);

          box-shadow:
            0 15px 35px
            rgba(0, 0, 0, 0.13);
        }


        /* ==============================
           IMAGE
        ============================== */

        .certificate-image-box {
          position: relative;

          width: 100%;

          height: 330px;

          background: #fff;

          overflow: hidden;
        }

        .certificate-image-box img {
          width: 100%;
          height: 100%;

          object-fit: contain;

          display: block;

          padding: 12px;

          transition:
            transform 0.5s ease;
        }

        .certificate-card:hover
        .certificate-image-box img {
          transform: scale(1.04);
        }


        /* ==============================
           OVERLAY
        ============================== */

        .certificate-overlay {
          position: absolute;

          inset: 0;

          display: flex;

          align-items: center;

          justify-content: center;

          background:
            rgba(53, 95, 45, 0.72);

          opacity: 0;

          transition:
            opacity 0.3s ease;
        }

        .certificate-card:hover
        .certificate-overlay {
          opacity: 1;
        }

        .certificate-overlay span {
          padding: 11px 20px;

          color: #4b8b3b;

          background: #fff;

          border-radius: 25px;

          font-size: 12px;

          font-weight: 700;
        }


        /* ==============================
           TITLE
        ============================== */

        .certificate-title {
          padding: 18px 15px;

          text-align: center;
        }

        .certificate-title h3 {
          margin: 0;

          color: #333;

          font-size: 15px;

          font-weight: 600;

          line-height: 1.4;
        }


        /* ==============================
           MODAL
        ============================== */

        .certificate-modal-overlay {
          position: fixed;

          inset: 0;

          z-index: 99999;

          display: flex;

          align-items: center;

          justify-content: center;

          padding: 20px;

          background:
            rgba(0, 0, 0, 0.8);

          backdrop-filter: blur(5px);
        }

        .certificate-modal {
          position: relative;

          width: 100%;

          max-width: 800px;

          max-height: 92vh;

          padding: 25px;

          overflow: auto;

          background: #fff;

          border-radius: 14px;

          text-align: center;
        }

        .certificate-modal img {
          width: 100%;

          max-height: 75vh;

          object-fit: contain;

          display: block;

          margin: auto;
        }

        .certificate-modal h3 {
          margin: 20px 0 0;

          color: #333;

          font-size: 20px;
        }


        /* ==============================
           CLOSE
        ============================== */

        .certificate-close {
          position: absolute;

          top: 10px;
          right: 10px;

          z-index: 5;

          width: 38px;
          height: 38px;

          border: none;

          border-radius: 50%;

          color: #333;

          background: #fff;

          font-size: 27px;

          line-height: 1;

          cursor: pointer;

          box-shadow:
            0 3px 12px
            rgba(0, 0, 0, 0.2);
        }

        .certificate-close:hover {
          color: #fff;

          background: #4b8b3b;
        }


        /* ==============================
           TABLET
        ============================== */

        @media (max-width: 991px) {

          .certificates-grid {
            grid-template-columns:
              repeat(2, 1fr);
          }

          .certificates-heading h2 {
            font-size: 36px;
          }

        }


        /* ==============================
           MOBILE
        ============================== */

        @media (max-width: 600px) {

          .certificates-section {
            padding: 60px 15px;
          }

          .certificates-heading {
            margin-bottom: 30px;
          }

          .certificates-heading h2 {
            font-size: 29px;
          }

          .certificates-heading p {
            font-size: 14px;
          }

          .certificates-grid {
            grid-template-columns: 1fr;

            gap: 20px;
          }

          .certificate-image-box {
            height: 360px;
          }

          .certificate-overlay {
            opacity: 1;

            align-items: flex-end;

            padding-bottom: 20px;

            background:
              linear-gradient(
                to top,
                rgba(53,95,45,0.5),
                transparent 35%
              );
          }

          .certificate-modal {
            padding: 15px;
          }

          .certificate-modal img {
            max-height: 70vh;
          }

        }

        `}
      </style>



{/* 
       <div className="container-fuild modern-clients-section" style={{ margin: "30px auto" }}>
  <center>
    <h3 className="title text-center font-weight-bold mt-1 mb-2 modern-clients-title">
      Our Clients
    </h3>
  </center>

  <div className="row modern-clients-grid" style={{ margin: "auto" }}>

    <div className="col-lg-2 col-sm-12 modern-client-card">
      <img src={client1} alt="" className="modern-client-logo" />
    </div>

    <div className="col-lg-2 col-sm-12 modern-client-card">
      <img src={client2} alt="" className="modern-client-logo" />
    </div>

    <div className="col-lg-2 col-sm-12 modern-client-card">
      <img src={client3} alt="" className="modern-client-logo" />
    </div>

    <div className="col-lg-2 col-sm-12 modern-client-card">
      <img src={client4} alt="" className="modern-client-logo" />
    </div>

    <div className="col-lg-2 col-sm-12 modern-client-card">
      <img src={client5} alt="" className="modern-client-logo" />
    </div>

    <div className="col-lg-2 col-sm-12 modern-client-card">
      <img src={client6} alt="" className="modern-client-logo" />
    </div>

  </div>
</div> */}





<section className="service-cta">
  <div className="container">

    {/* Heading */}
    <div className="cta-head">
      <p>WHY CHOOSE US?</p>
      <h2>Expert Garden & Landscaping Services</h2>
    </div>

    {/* Contact Bar */}
    <div className="cta-contact">
      <h4>Talk to a garden expert</h4>
      <p>
        Call us at <a href="tel:+971509480695">+971 50 948 0695</a> or fill out a
        form. We will be glad to help you.
      </p>
      <a href="/contact" className="cta-main-btn">Contact Us</a>
    </div>

    {/* Cards */}
    <div className="cta-cards">

      <div className="cta-card">
        <i className="fas fa-calendar-check"></i>
        <h4>Online Booking</h4>
        <p>
          Book garden maintenance or landscaping services online and get
          professional gardeners at your location.
        </p>
        <a href="https://wa.me/971509480695?text=Hi *Garden Oasis Landscape *! I need more info about Garden Oasis Landscape  https://gardenoasislandscape.com" className="cta-btn">Book Garden Service</a>
      </div>

      <div className="cta-card">
        <i className="fas fa-seedling"></i>
        <h4>Professional Garden Care</h4>
        <p>
          Our experienced team ensures healthy plants, clean landscapes and
          beautiful outdoor spaces all year round.
        </p>
        <a href="https://gardenoasislandscape.com/best-annual-maintenance-contract-packages" className="cta-btn">View Services</a>
      </div>

      <div className="cta-card">
        <i className="fas fa-map-marker-alt"></i>
        <h4>Visit Our Nursery</h4>
        <p>
          Visit our plant nursery to explore indoor and outdoor plants suitable
          for UAE climate and landscaping needs.
        </p>
        <a href="https://maps.app.goo.gl/y3s23ZVWrBwqH35f7" className="cta-btn">Get Directions</a>
      </div>

    </div>

  </div>
</section>




<section className="commitment">
  <div className="container">

    {/* Heading */}
    <div className="commitment-head">
      <p>OUR COMMITMENT</p>
      <h2>Why Choose Garden Oasis Landscaping?</h2>
      <span className="commitment-line"></span>
    </div>

    {/* Cards */}
    <div className="commitment-grid">
      {[
        {
          img: "/images/experience.jpg",
          title: "25+ Years Experience",
          desc: "Our proven expertise ensures your garden receives the best care, design and long-term maintenance."
        },
        {
          img: "/images/customerservice.jpg",
          title: "Customer Satisfaction",
          desc: "We understand your needs and deliver personalized landscaping solutions with complete satisfaction."
        },
        {
          img: "/images/plants-selection.jpg",
          title: "Wide Plant Selection",
          desc: "Choose from a wide range of indoor and outdoor plants suitable for Dubai’s climate conditions."
        },
        {
          img: "/images/sustainability.jpg",
          title: "Eco-Friendly Practices",
          desc: "We follow sustainable and environmentally responsible landscaping practices for a greener future."
        }
      ].map((item, index) => (
        <div className="commitment-card" key={index}>
          <div className="commitment-img">
            {/* <img src={item.img} alt={item.title} /> */}
          </div>
          <div className="commitment-content">
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        </div>
      ))}
    </div>

  </div>
</section>





{/* <div className="container-fuild modern-portfolio-section" style={{ margin: "30px auto" }}>
  <center>
    <h3 className="title text-center font-weight-bold mt-1 mb-2 modern-portfolio-title">
      Our Portfolio
    </h3>
  </center>

  <div className="row modern-portfolio-grid">

    <div className="col-lg-4 col-sm-12 modern-portfolio-card">
      <img src={port1} alt="" className="modern-portfolio-img" />
    </div>

    <div className="col-lg-4 col-sm-12 modern-portfolio-card">
      <img src={port2} alt="" className="modern-portfolio-img" />
    </div>

    <div className="col-lg-4 col-sm-12 modern-portfolio-card">
      <img src={port3} alt="" className="modern-portfolio-img" />
    </div>

    <div className="col-lg-4 col-sm-12 modern-portfolio-card">
      <img src={port4} alt="" className="modern-portfolio-img" />
    </div>

    <div className="col-lg-4 col-sm-12 modern-portfolio-card">
      <img src={port5} alt="" className="modern-portfolio-img" />
    </div>

    <div className="col-lg-4 col-sm-12 modern-portfolio-card">
      <img src={port6} alt="" className="modern-portfolio-img" />
    </div>

  </div>
</div> */}


{/* <section className="modern-projects-section">
  <div className="container">

    <h3 className="modern-projects-title">
      Our Portfolio
    </h3>
    <span className="modern-projects-line"></span>

    <div className="modern-projects-grid">
      {[port1, port2, port3, port4, port5, port6].map((img, index) => (
        <div className="modern-project-card" key={index}>
          <img src={img} alt={`Project ${index + 1}`} className="modern-project-img" />
        </div>
      ))}
    </div>
  </div>
</section> */}
          

         

<section className="modern-about-section">
  <div className="container">

    {/* Main Heading */}
    <h1 className="modern-about-heading">
      Your Premier Destination for Indoor & Outdoor Plants & Landscaping Solutions in Dubai
    </h1>

    {/* Intro Paragraph */}
    <p className="modern-about-text">
      At Garden Oasis Landscaping, we're dedicated to bringing the beauty of nature into your home space in Dubai. With a diverse selection of plants and garden accessories, we aim to create your own oasis of tranquility and greenery. With over 25 years of experience in the industry, our passionate team is committed to helping you transform your space into a vibrant and thriving garden paradise. Whether you're a seasoned gardener or just starting out, we're here to provide expert guidance and top-quality products to enhance your gardening experience. Explore our range and let your imagination bloom with Garden Oasis Landscaping.
    </p>

    {/* Mission */}
    <h5 className="modern-about-subtitle">Our Mission:</h5>
    <p className="modern-about-text">
      At Garden Oasis Landscaping, we are on a mission to bring nature's beauty into every home in Dubai. With our diverse selection of plants and garden accessories, we aim to inspire and empower our customers to create their own green sanctuaries.
    </p>

    {/* Expertise */}
    <h5 className="modern-about-subtitle">Expertise and Experience:</h5>
    <p className="modern-about-text">
      With over 25 years of experience in the industry, Garden Oasis Landscaping boasts a team of passionate experts dedicated to providing the highest quality plants and accessories. Our team's wealth of knowledge ensures that you receive expert guidance and support every step of the way.
    </p>

    {/* Product Categories */}
    <h5 className="modern-about-subtitle">Product Categories:</h5>
    <ul className="modern-about-list">
      <li><strong>Indoor Plants:</strong> Bring the beauty of nature indoors with our selection of lush greenery and vibrant blooms.</li>
      <li><strong>Outdoor Plants:</strong> Transform your outdoor space into a thriving oasis with our diverse range of outdoor plants suitable for Dubai's climate.</li>
      <li><strong>Garden Accessories:</strong> Enhance your gardening experience with our collection of high-quality accessories, including pots, planters, tools, and more.</li>
      <li><strong>Seeds and Fertilizers:</strong> Start your gardening journey from scratch with our premium seeds and fertilizers, carefully selected to ensure optimal growth and health of your plants.</li>
    </ul>

    {/* Transform Your Space */}
    <h5 className="modern-about-subtitle">Transform Your Space:</h5>
    <p className="modern-about-text">
      Whether you're a seasoned gardener or a novice enthusiast, Garden Oasis Landscaping is here to help you transform your space into a vibrant and thriving garden paradise. Explore our range today and let your imagination bloom with Garden Oasis Landscaping.
    </p>

    {/* Services CTA */}
    <h5 className="modern-about-subtitle">Our Services</h5>
    <p className="modern-about-text">
      We offer a wide range of services including garden maintenance, landscaping, outdoor plant installations, villa garden care, and professional consultation to make your garden dreams a reality.
    </p>

  </div>
</section>


{/* <div
  className="container modern-about-section"
  style={{ margin: "30px 10px", width: "96%" }}
>
  <div className="row">
    <div className="col-lg-12 col-sm-12 modern-about-content">

    


  <p>
    <Link style={{padding: "10px"}} to="/villa-maintenance-contract-dubai-villa-amc-dubai">Villa Maintenance Contract Dubai Villa AMC Dubai</Link>
    <Link style={{padding: "10px"}} to="/best-annual-maintenance-contract-packages">Best Annual Maintenance Contract Packages</Link>
    <Link style={{padding: "10px"}} to="/annual-maintenance-contract-in-dubai">Annual Maintenance Contract in Dubai</Link>
    <Link style={{padding: "10px"}} to="/annual-maintenance-contracts-dubai">AMC in dubai</Link>
    <Link style={{padding: "10px"}} to="/amc-packages-dubai-annual-maintenance-contract">AMC Packages Dubai Annual Maintenance Contract</Link>
   
    <Link style={{padding: "10px"}} to="/Indoor Plant Maintenance Service (AMC) in Dubai"> Indoor Plant Maintenance Service (AMC) in Dubai</Link>
    <Link style={{padding: "10px"}} to="/Annual Maintenance Contract Dubai AMC Services in UAE">Annual Maintenance Contract Dubai | AMC Services in UAE </Link>
    <Link style={{padding: "10px"}} to="/Garden Maintenance AMC Services at Discounted Prices">Garden Maintenance AMC Services at Discounted Prices </Link>
    <Link style={{padding: "10px"}} to="/Dubai Landscape Maintenance - Beautiful Gardens Made Easy">Dubai Landscape Maintenance - Beautiful Gardens Made Easy </Link>
    <Link style={{padding: "10px"}} to="/Garden Maintenance AMC Services at Best Offers">Garden Maintenance AMC Services at Best Offers </Link>
    <Link style={{padding: "10px"}} to="/Looking For AMC for Your Lawn? Garden Maintenance Services">Looking For AMC for Your Lawn? | Garden Maintenance Services
    </Link>
    <Link style={{padding: "10px"}} to="/Garden Maintenance Services Landscaping Services in Dubai"> Garden Maintenance Services | Landscaping Services in Dubai 
    </Link>
    <Link style={{padding: "10px"}} to="/Annual Indoor Plant Maintenance Plant care service Dubai"> Annual Indoor Plant Maintenance #1 Plant care service Dubai
    </Link>


    <Link style={{padding: "10px"}} to="/Landscaping Companies in Dubai - Landscaping in Dubai"> Landscaping Companies in Dubai - Landscaping in Dubai
    </Link>
    <Link style={{padding: "10px"}} to="/Landscaping Company Dubai Landscaping designer"> Landscaping Company Dubai | Landscaping designer
    </Link>
    <Link style={{padding: "10px"}} to="/Best Landscaping Company in Dubai"> Best Landscaping Company in Dubai
    </Link>
    <Link style={{padding: "10px"}} to="/Landscaping Dubai | Landscaping Company Dubai"> Landscaping Dubai | Landscaping Company Dubai 
    </Link>
    <Link style={{padding: "10px"}} to="/Desert Group | Best and Quality Landscaping Company in Dubai"> Desert Group | Best and Quality Landscaping Company in Dubai
    </Link>
    <Link style={{padding: "10px"}} to="/Premium Landscaping Company in Dubai"> Premium Landscaping Company in Dubai 
    </Link>
    <Link style={{padding: "10px"}} to="/Best in Dubai Landscapes | Best UAE Landscaping"> Best in Dubai Landscapes | Best UAE Landscaping
    </Link>
    <Link style={{padding: "10px"}} to="/Landscaping Services Dubai"> Landscaping Services Dubai
    </Link>
    <Link style={{padding: "10px"}} to="/Landscaping Services | Garden Landscaping Company in Dubai"> Landscaping Services | Garden Landscaping Company in Dubai
    </Link>
    <Link style={{padding: "10px"}} to="/Your Top Landscaping Company in Dubai | Planters"> Your Top Landscaping Company in Dubai | Planters
    </Link>
    <Link style={{padding: "10px"}} to="/Best landscape architecture in Dubai - Outdoor Living"> Best landscape architecture in Dubai - Ducon Outdoor Living
    </Link>
    <Link style={{padding: "10px"}} to="/Landscaping and Gardening services company – Dubai"> Landscaping and Gardening services company – Dubai
    </Link>
    <Link style={{padding: "10px"}} to="/Landscaping Services | Dubai | UAE"> Landscaping Services | Dubai | Abu Dhabi | UAE
    </Link>
    <Link style={{padding: "10px"}} to="/One of the best landscaping companies in Dubai"> One of the best landscaping companies in Dubai
    </Link>
    <Link style={{padding: "10px"}} to="/Best Landscaping Company in Dubai | UAE"> Best Landscaping Company in Dubai | UAE
    </Link>
    <Link style={{padding: "10px"}} to="/Gardening Services in Dubai | Top Landscaping & Gardening"> Gardening Services in Dubai | Top Landscaping & Gardening
    </Link>


    
    <Link style={{padding: "10px"}} to="/benefits-of-annual-maintenance-contracts-for-your-garden-plant-in-dubai-with-garden-oasis-landscape-service"> Benefits of Annual Maintenance Contracts for Your Garden Plant in Dubai with Garden Oasis Landscape Service
    </Link>



    <Link style={{padding: "10px"}} to="/get-high-quality-artificial-grass-and-transform-your-outdoor-space-at-our-store"> 
   
    Get High-Quality Artificial Grass And Transform Your Outdoor Space At Our Store </Link>
    <Link style={{padding: "10px"}} to="/what-is-landscape-design"> 
    What is Landscape Design

    </Link>





    <Link style={{padding: "10px"}} to="/garden-maintenance-services-dubai"> Garden Maintenance Services Dubai
    </Link>
    <Link style={{padding: "10px"}} to="/top-rated-landscaping-and-plant-maintenance-services-dubai"> Top-Rated Landscaping and Plant Maintenance Services Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/premium-garden-maintenance-services-dubai"> Premium Garden Maintenance Services Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/best-landscaping-and-gardening-services-company-in-dubai"> Best Landscaping & Gardening Services Company in Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/garden-landscaping-dubai-expert-garden-care"> Garden Landscaping Dubai - Expert Garden Care

    </Link>
    <Link style={{padding: "10px"}} to="/book-professional-garden-maintenance-services-in-dubai"> Book Professional Garden Maintenance Services In Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/garden-landscaping-dubai-trusted-#1-gardeners-in-dubai">Garden Landscaping Dubai | Trusted #1 Gardeners in Dubai
 
    </Link>
    <Link style={{padding: "10px"}} to="/dubai-best-landscaping-and-garden-maintenance"> Dubai Best Landscaping And Garden Maintenance

    </Link>
    <Link style={{padding: "10px"}} to="/your-top-landscaping-company-in-dubai"> Your Top Landscaping Company in Dubai 

    </Link>
    <Link style={{padding: "10px"}} to="/top-indoor-plants-maintenance-service-dubai"> Top Indoor Plants Maintenance Service Dubai 

    </Link>
    <Link style={{padding: "10px"}} to="/landscape-and-gardening-works-and-maintenance-in-dubai"> Landscape & Gardening works & Maintenance in Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/affordable-gardening-services-in-dubai"> Affordable Gardening Services in Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/landscaping-and-gardening-services-company-dubai"> Landscaping and Gardening services company – Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/urban-landscapes-luxury-landscaping-design-dubai"> Urban Landscapes | Luxury Landscaping Design Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/best-dubai-landscape-dubai-top-landscaping-firm"> Best Dubai Landscape | Dubai's top landscaping firm

    </Link>
    <Link style={{padding: "10px"}} to="/one-of-the-best-landscaping-companies-in-dubai"> One of the best landscaping companies in Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/premium-landscaping-company-in-dubai"> Premium Landscaping Company in Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/best-choice-landscape-gardening-llc-dubai"> Best Choice Landscape Gardening LLC Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/landscaping-in-dubai-greenlawn-landscaping-and-gardening"> Landscaping in Dubai | Greenlawn Landscaping & gardening

    </Link>
    <Link style={{padding: "10px"}} to="/best-landscaping-and-lawn-service-in-dubai"> Best Landscaping And Lawn Service In Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/expert-garden-landscaping-in-dubai-for-your-outdoor-oasis"> Expert Garden Landscaping in Dubai for Your Outdoor Oasis

    </Link>
    <Link style={{padding: "10px"}} to="/best-gardening-companies-landscaping-work-in-dubai"> Best Gardening Companies Landscaping Work in Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/dubai-landscaping-home-office-landscape-indoor-outdoor-#1"> Dubai Landscaping | Home office Landscape Indoor Outdoor #1

    </Link>
    <Link style={{padding: "10px"}} to="/best-landscaping-companies-in-dubai-villa-garden"> Best Landscaping Companies in Dubai-Villa Garden

    </Link>
    <Link style={{padding: "10px"}} to="/landscaping-services-in-uae-landscaping-company-in-dubai"> Landscaping Services in UAE: Landscaping Company in Dubai

    </Link>
    <Link style={{padding: "10px"}} to="/#1-swimming-pool-and-landscaping-company-in-dubai-uae"> #1 Swimming Pool and Landscaping Company in Dubai, UAE 
    </Link>

    <Link style={{ padding: "10px" }} to="/best-landscaping-company-arabian-ranches">Best Landscaping Company in Arabian Ranches</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-company-dubai-marina">Best Landscaping Company in Dubai Marina</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-company-jumeirah-beach-residence">Best Landscaping Company in Jumeirah Beach Residence (JBR)</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-company-al-barsha">Best Landscaping Company in Al Barsha</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-company-downtown-dubai">Best Landscaping Company in Downtown Dubai</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-company-business-bay">Best Landscaping Company in Business Bay</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-company-al-quoz">Best Landscaping Company in Al Quoz</Link>
      <Link style={{ padding: "10px" }} to="/top-garden-design-company-dubai">Top Garden Design Company in Dubai</Link>
      <Link style={{ padding: "10px" }} to="/best-tree-supplier-dubai">Best Tree Supplier in Dubai</Link>
      <Link style={{ padding: "10px" }} to="/best-tree-exporter-dubai">Best Tree Exporter in Dubai</Link>
      <Link style={{ padding: "10px" }} to="/leading-irrigation-system-provider-dubai">Leading Irrigation System Provider in Dubai</Link>
      <Link style={{ padding: "10px" }} to="/premium-plant-nursery-dubai">Premium Plant Nursery in Dubai</Link>
      <Link style={{ padding: "10px" }} to="/best-outdoor-lighting-solutions-dubai">Best Outdoor Lighting Solutions in Dubai</Link>
      <Link style={{ padding: "10px" }} to="/best-landscape-maintenance-company-dubai">Best Landscape Maintenance Company in Dubai</Link>
      <Link style={{ padding: "10px" }} to="/top-hardscape-company-dubai">Top Hardscape Company in Dubai</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-service-arabian-ranches-1-2">Best Landscaping Service in Arabian Ranches 1 & 2</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-service-dubai-hills-estate">Best Landscaping Service in Dubai Hills Estate</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-service-emirates-hills">Best Landscaping Service in Emirates Hills</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-service-jumeirah">Best Landscaping Service in Jumeirah</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-service-jumeirah-golf-estate">Best Landscaping Service in Jumeirah Golf Estate</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-service-dubai-investment-park">Best Landscaping Service in Dubai Investment Park (DIP)</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-service-dubai-international-centre">Best Landscaping Service in Dubai International Centre (DIFC)</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-service-dubai">Best Landscaping Service in Dubai</Link>
      <Link style={{ padding: "10px" }} to="/best-landscaping-service-uae">Best Landscaping Service in UAE</Link>
      <Link style={{ padding: "10px" }} to="/no1-landscaping-company-dubai">No. 1 Landscaping Company in Dubai</Link>
      <Link style={{ padding: "10px" }} to="/top-landscaping-company-dubai">Top Landscaping Company in Dubai</Link>



      <Link style={{padding: "10px"}} to="/landscape-architects-dubai">Landscape Architects Dubai</Link>
<Link style={{padding: "10px"}} to="/landscape-design-company">Landscape Design Company</Link>
<Link style={{padding: "10px"}} to="/commercial-landscaping-company-in-dubai">Commercial Landscaping Company in Dubai</Link>
<Link style={{padding: "10px"}} to="/residential-landscaping-company-in-dubai">Residential Landscaping Company in Dubai</Link>
<Link style={{padding: "10px"}} to="/hardscaping-company-in-dubai">Hardscaping Company in Dubai</Link>
<Link style={{padding: "10px"}} to="/garden-installation-company-in-dubai">Garden Installation Company in Dubai</Link>
<Link style={{padding: "10px"}} to="/horticulture-services-dubai">Horticulture Services in Dubai</Link>
<Link style={{padding: "10px"}} to="/outdoor-landscaping-service">Outdoor Landscaping Service</Link>
<Link style={{padding: "10px"}} to="/outdoor-landscaping-service-in-dubai">Outdoor Landscaping Service in Dubai</Link>
<Link style={{padding: "10px"}} to="/outdoor-plant-service-in-dubai">Outdoor Plant Service in Dubai</Link>
<Link style={{padding: "10px"}} to="/outdoor-plant-company-in-dubai">Outdoor Plant Company in Dubai</Link>
<Link style={{padding: "10px"}} to="/plant-supply-dubai">Plant Supply Dubai</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale-dubai">Plant Wholesale Dubai</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale-arjan">Plant Wholesale Arjan</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale-shop-dubai">Plant Wholesale Shop Dubai</Link>
<Link style={{padding: "10px"}} to="/best-lawn-care-services">Best Lawn Care Services</Link>
<Link style={{padding: "10px"}} to="/grass-installation-dubai">Grass Installation Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-arjan">Landscaping Service in Arjan</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-uae">Landscaping Service in UAE</Link>
<Link style={{padding: "10px"}} to="/landscaping-company-arjan">Landscaping Company in Arjan</Link>
<Link style={{padding: "10px"}} to="/garden-shop-arjan-dubai">Garden Shop in Arjan Dubai</Link>
<Link style={{padding: "10px"}} to="/plant-shop-arjan-dubai">Plant Shop in Arjan Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plant-shop-arjan-dubai">Indoor Plant Shop in Arjan Dubai</Link>





      <Link style={{ padding: "10px" }} to="/garden-shop-meydan-dubai">Garden Shop Meydan Dubai</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-meydan-dubai">Landscaping Service Meydan Dubai</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-design-district">Garden Shop Design District</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-design-district">Landscaping Service Design District</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-barari-dubai">Garden Shop Barari Dubai</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-barari-dubai">Landscaping Service Barari Dubai</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-al-furjan">Garden Shop Al Furjan</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-al-furjan">Landscaping Service Al Furjan</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-tilal-al-ghaf">Garden Shop Tilal Al Ghaf</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-tilal-al-ghaf">Landscaping Service Tilal Al Ghaf</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-arabian-ranches-2">Garden Shop Arabian Ranches 2</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-arabian-ranches-2">Landscaping Service Arabian Ranches 2</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-tilal-al-furjan">Garden Shop Tilal Al Furjan</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-tilal-al-furjan">Landscaping Service Tilal Al Furjan</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-al-wasl-gate">Garden Shop Al Wasl Gate</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-al-wasl-gate">Landscaping Service Al Wasl Gate</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-damac-hills">Garden Shop Damac Hills</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-damac-hills">Landscaping Service Damac Hills</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-emaar-south">Garden Shop Emaar South</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-emaar-south">Landscaping Service Emaar South</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-sobha-hartland">Garden Shop Sobha Hartland</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-sobha-hartland">Landscaping Service Sobha Hartland</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-meraas">Garden Shop Meraas</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-meraas">Landscaping Service Meraas</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-samana">Garden Shop Samana</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-samana">Landscaping Service Samana</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-california-village">Garden Shop California Village</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-california-village">Landscaping Service California Village</Link>

      <Link style={{ padding: "10px" }} to="/garden-shop-falcon-city-of-wonders">Garden Shop Falcon City of Wonders</Link>
      <Link style={{ padding: "10px" }} to="/landscaping-service-falcon-city-of-wonders">Landscaping Service Falcon City of Wonders</Link>


      <Link style={{ padding: "10px" }} to="/indoor-plant-shop-meydan-dubai">Indoor Plant Shop Meydan Dubai</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-design-district">Indoor Plant Shop Design District</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-barari-dubai">Indoor Plant Shop Barari Dubai</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-al-furjan">Indoor Plant Shop Al Furjan</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-tilal-al-ghaf">Indoor Plant Shop Tilal Al Ghaf</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-arabian-ranches-2">Indoor Plant Shop Arabian Ranches 2</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-tilal-al-furjan">Indoor Plant Shop Tilal Al Furjan</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-al-wasl-gate">Indoor Plant Shop Al Wasl Gate</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-damac-hills">Indoor Plant Shop Damac Hills</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-emaar-south">Indoor Plant Shop Emaar South</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-sobha-hartland">Indoor Plant Shop Sobha Hartland</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-meraas">Indoor Plant Shop Meraas</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-samana">Indoor Plant Shop Samana</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-california-village">Indoor Plant Shop California Village</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-falcon-city-of-wonders">Indoor Plant Shop Falcon City of Wonders</Link>
<Link style={{ padding: "10px" }} to="/indoor-plant-shop-dubai">Indoor Plant Shop Dubai</Link>

<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-dubai">Outdoor Plant Shop Dubai</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-arjan">Outdoor Plant Shop Arjan</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-meydan-dubai">Outdoor Plant Shop Meydan Dubai</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-design-district">Outdoor Plant Shop Design District</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-barari-dubai">Outdoor Plant Shop Barari Dubai</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-al-furjan">Outdoor Plant Shop Al Furjan</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-tilal-al-ghaf">Outdoor Plant Shop Tilal Al Ghaf</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-arabian-ranches-2">Outdoor Plant Shop Arabian Ranches 2</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-tilal-al-furjan">Outdoor Plant Shop Tilal Al Furjan</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-al-wasl-gate">Outdoor Plant Shop Al Wasl Gate</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-damac-hills">Outdoor Plant Shop Damac Hills</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-emaar-south">Outdoor Plant Shop Emaar South</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-sobha-hartland">Outdoor Plant Shop Sobha Hartland</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-meraas">Outdoor Plant Shop Meraas</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-samana">Outdoor Plant Shop Samana</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-california-village">Outdoor Plant Shop California Village</Link>
<Link style={{ padding: "10px" }} to="/outdoor-plant-shop-falcon-city-of-wonders">Outdoor Plant Shop Falcon City of Wonders</Link>





<Link style={{ padding: "10px" }} to="/best-soil-for-gardening-in-dubai">Best Soil for Gardening in Dubai</Link>
<Link style={{ padding: "10px" }} to="/premium-soil-suppliers-in-dubai">Premium Soil Suppliers in Dubai</Link>
<Link style={{ padding: "10px" }} to="/buy-organic-soil-for-plants-in-dubai">Buy Organic Soil for Plants in Dubai</Link>
<Link style={{ padding: "10px" }} to="/top-quality-stones-for-landscaping-in-dubai">Top Quality Stones for Landscaping in Dubai</Link>
<Link style={{ padding: "10px" }} to="/soil-and-stone-delivery-service-in-dubai">Soil and Stone Delivery Service in Dubai</Link>
<Link style={{ padding: "10px" }} to="/landscaping-soil-solutions-in-dubai">Landscaping Soil Solutions in Dubai</Link>
<Link style={{ padding: "10px" }} to="/affordable-soil-for-planting-in-dubai">Affordable Soil for Planting in Dubai</Link>
<Link style={{ padding: "10px" }} to="/best-garden-stones-for-dubai-gardens">Best Garden Stones for Dubai Gardens</Link>
<Link style={{ padding: "10px" }} to="/dubais-leading-soil-and-stone-providers">Dubai's Leading Soil and Stone Providers</Link>
<Link style={{ padding: "10px" }} to="/garden-soil-for-dubais-climate-and-terrain">Garden Soil for Dubai's Climate and Terrain</Link>

<Link style={{ padding: "10px" }} to="/organic-fertilizers-for-dubai-gardens">Organic Fertilizers for Dubai Gardens</Link>
<Link style={{ padding: "10px" }} to="/best-pesticides-for-indoor-plants-in-dubai">Best Pesticides for Indoor Plants in Dubai</Link>
<Link style={{ padding: "10px" }} to="/premium-fertilizers-for-dubai-plants">Premium Fertilizers for Dubai Plants</Link>
<Link style={{ padding: "10px" }} to="/safe-and-effective-pesticides-in-dubai">Safe and Effective Pesticides in Dubai</Link>
<Link style={{ padding: "10px" }} to="/buy-fertilizers-online-in-dubai">Buy Fertilizers Online in Dubai</Link>
<Link style={{ padding: "10px" }} to="/eco-friendly-fertilizers-for-gardens-in-dubai">Eco-Friendly Fertilizers for Gardens in Dubai</Link>
<Link style={{ padding: "10px" }} to="/pest-control-products-for-dubai-homes">Pest Control Products for Dubai Homes</Link>
<Link style={{ padding: "10px" }} to="/fertilizer-solutions-for-dubais-climate">Fertilizer Solutions for Dubai's Climate</Link>
<Link style={{ padding: "10px" }} to="/top-rated-fertilizer-suppliers-in-dubai">Top-Rated Fertilizer Suppliers in Dubai</Link>
<Link style={{ padding: "10px" }} to="/dubais-leading-pesticide-distributors">Dubai's Leading Pesticide Distributors</Link>

<Link style={{ padding: "10px" }} to="/stylish-pots-and-planters-in-dubai">Stylish Pots and Planters in Dubai</Link>
<Link style={{ padding: "10px" }} to="/buy-outdoor-planters-in-dubai">Buy Outdoor Planters in Dubai</Link>
<Link style={{ padding: "10px" }} to="/modern-pots-for-indoor-plants-in-dubai">Modern Pots for Indoor Plants in Dubai</Link>
<Link style={{ padding: "10px" }} to="/best-planters-for-dubais-weather">Best Planters for Dubai's Weather</Link>
<Link style={{ padding: "10px" }} to="/high-quality-pots-for-dubai-gardens">High-Quality Pots for Dubai Gardens</Link>
<Link style={{ padding: "10px" }} to="/affordable-planters-for-home-gardens-in-dubai">Affordable Planters for Home Gardens in Dubai</Link>
<Link style={{ padding: "10px" }} to="/custom-planters-for-dubai-homes">Custom Planters for Dubai Homes</Link>
<Link style={{ padding: "10px" }} to="/elegant-flower-pots-in-dubai">Elegant Flower Pots in Dubai</Link>
<Link style={{ padding: "10px" }} to="/large-pots-for-dubai-landscaping">Large Pots for Dubai Landscaping</Link>
<Link style={{ padding: "10px" }} to="/potting-solutions-for-dubai-gardens">Potting Solutions for Dubai Gardens</Link>

<Link style={{ padding: "10px" }} to="/artificial-plants-for-dubai-homes">Artificial Plants for Dubai Homes</Link>
<Link style={{ padding: "10px" }} to="/best-artificial-indoor-plants-in-dubai">Best Artificial Indoor Plants in Dubai</Link>
<Link style={{ padding: "10px" }} to="/buy-realistic-artificial-plants-in-dubai">Buy Realistic Artificial Plants in Dubai</Link>
<Link style={{ padding: "10px" }} to="/low-maintenance-artificial-plants-for-dubai">Low Maintenance Artificial Plants for Dubai</Link>
<Link style={{ padding: "10px" }} to="/top-artificial-plants-suppliers-in-dubai">Top Artificial Plants Suppliers in Dubai</Link>
<Link style={{ padding: "10px" }} to="/faux-plants-for-office-spaces-in-dubai">Faux Plants for Office Spaces in Dubai</Link>
<Link style={{ padding: "10px" }} to="/beautiful-artificial-plants-for-dubai-gardens">Beautiful Artificial Plants for Dubai Gardens</Link>
<Link style={{ padding: "10px" }} to="/best-artificial-flowers-for-dubai-interiors">Best Artificial Flowers for Dubai Interiors</Link>
<Link style={{ padding: "10px" }} to="/indoor-artificial-plants-for-dubai-apartments">Indoor Artificial Plants for Dubai Apartments</Link>
<Link style={{ padding: "10px" }} to="/dubais-leading-artificial-plant-retailers">Dubai's Leading Artificial Plant Retailers</Link>


<Link style={{padding: "10px"}} to="/outdoor-planters-for-dubai-harbour-homes">Outdoor planters for Dubai Harbour homes</Link>
<Link style={{padding: "10px"}} to="/buy-artificial-plants-in-dubai-harbour">Buy artificial plants in Dubai Harbour</Link>
<Link style={{padding: "10px"}} to="/eco-friendly-fertilizers-dubai-harbour">Eco-friendly fertilizers Dubai Harbour</Link>
<Link style={{padding: "10px"}} to="/garden-maintenance-services-in-dubai-harbour">Garden maintenance services in Dubai Harbour</Link>
<Link style={{padding: "10px"}} to="/stylish-indoor-plants-dubai-harbour">Stylish indoor Plants Dubai Harbour</Link>
<Link style={{padding: "10px"}} to="/top-gardening-shop-in-dubai-harbour">Top gardening shop in Dubai Harbour</Link>
<Link style={{padding: "10px"}} to="/indoor-plant-shop-in-mbr-city-dubai">Indoor plant shop in MBR City Dubai</Link>
<Link style={{padding: "10px"}} to="/buy-fertilizers-near-mohammed-rashid-al-maktoum-city">Buy fertilizers near Mohammed Rashid Al Maktoum City</Link>
<Link style={{padding: "10px"}} to="/landscaping-services-in-mohammed-rashid-al-maktoum-city">Landscaping services in Mohammed Rashid Al Maktoum City</Link>
<Link style={{padding: "10px"}} to="/stylish-pots-and-planters-in-mbr-city-dubai">Stylish pots and planters in MBR City Dubai</Link>
<Link style={{padding: "10px"}} to="/organic-garden-supplies-in-mohammed-rashid-al-maktoum-city">Organic garden supplies in Mohammed Rashid Al Maktoum City</Link>
<Link style={{padding: "10px"}} to="/buy-outdoor-plants-in-mohammed-rashid-al-maktoum-city">Buy outdoor plants in Mohammed Rashid Al Maktoum City</Link>
<Link style={{padding: "10px"}} to="/artificial-plants-for-homes-in-mbr-city">Artificial plants for homes in MBR City</Link>
<Link style={{padding: "10px"}} to="/premium-gardening-tools-in-mohammed-rashid-al-maktoum-city">Premium gardening tools in Mohammed Rashid Al Maktoum City</Link>
<Link style={{padding: "10px"}} to="/garden-stones-and-pebbles-near-mbr-city">Garden stones and pebbles near MBR City</Link>
<Link style={{padding: "10px"}} to="/balcony-plant-setup-in-mohammed-rashid-al-maktoum-city">Balcony plant setup in Mohammed Rashid Al Maktoum City</Link>
<Link style={{padding: "10px"}} to="/garden-maintenance-services-mbr-city">Garden maintenance services MBR City</Link>
<Link style={{padding: "10px"}} to="/buy-flower-pots-in-mohammed-rashid-al-maktoum-city">Buy flower pots in Mohammed Rashid Al Maktoum City</Link>
<Link style={{padding: "10px"}} to="/affordable-planters-for-mbr-city-residents">Affordable planters for MBR City residents</Link>
<Link style={{padding: "10px"}} to="/home-garden-makeover-in-mbr-city">Home garden makeover in MBR City</Link>
<Link style={{padding: "10px"}} to="/indoor-gardening-solutions-mbr-city-apartments">Indoor gardening solutions MBR City apartments</Link>
<Link style={{padding: "10px"}} to="/organic-fertilizers-near-dubai-harbour">Organic fertilizers near Dubai Harbour</Link>
<Link style={{padding: "10px"}} to="/garden-landscaping-services-in-dubai-harbour">Garden landscaping services in Dubai Harbour</Link>
<Link style={{padding: "10px"}} to="/buy-plant-pots-in-dubai-harbour">Buy plant pots in Dubai Harbour</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-delivery-dubai-harbour">Indoor plants delivery Dubai Harbour</Link>

     


<Link style={{padding: "10px"}} to="/indoor-plants-act-one-act-two-dubai">Indoor Plant Act One Act Two Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-address-opera-dubai">Indoor Plant Address Opera Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-bel-air-dubai">Indoor Plant Bel Air Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-bliss-1-2-dubai">Indoor Plant Bliss 1 & 2 Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-burj-crown-dubai">Indoor Plant Burj Crown Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-emaar-oasis-dubai">Indoor Plant Emaar Oasis Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-golf-acres-dubai-south">Indoor Plant Golf Acres Dubai South</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-golf-dale-dubai-south">Indoor Plant Golf Dale Dubai South</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-golf-edge-dubai-south">Indoor Plant Golf Edge Dubai South</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-golf-lane-dubai-south">Indoor Plant Golf Lane Dubai South</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-golf-links-dubai-south">Indoor Plant Golf Links Dubai South</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-golf-links-1-2-dubai-south">Indoor Plant Golf Links 1 & 2 Dubai South</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-green-ridge-dubai-south">Indoor Plant Green Ridge Dubai South</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-greens-point-dubai-south">Indoor Plant Greens Point Dubai South</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-green-ville-dubai-south">Indoor Plant Green Ville Dubai South</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-green-way-1-2-dubai-south">Indoor Plant Green Way 1 & 2 Dubai South</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-luxur-tower-imtiaz">Indoor Plant Luxur Tower Imtiaz</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-majara-dm-dubai">Indoor Plant Majara DM Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-maple-1-2-3-dubai">Indoor Plant Maple 1 2 3 Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-sirda-1-2-3-dubai">Indoor Plant Sirda 1 2 3 Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-park-residences-dubai">Indoor Plant Park Residences Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-pearl-house-imtiaz">Indoor Plant Pearl House Imtiaz</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-r3-ruba-dubai">Indoor Plant R3 Ruba Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-raya-1-dubai">Indoor Plant Raya 1 Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-reportage-village-dubai">Indoor Plant Reportage Village Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-silver-spring-trump-estate-2">Indoor Plant Silver Spring Trump Estate 2</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-silver-springs-dubai">Indoor Plant Silver Springs Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-sobha-creek-vistas-grande">Indoor Plant Sobha Creek Vistas Grande</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-south-bay-dubai-south">Indoor Plant South Bay Dubai South</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-the-valley-dubai">Indoor Plant The Valley Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-veneto-1-dubai">Indoor Plant Veneto 1 Dubai</Link>
<Link style={{padding: "10px"}} to="/indoor-plants-westwood-grande-ii-imtiaz">Indoor Plant Westwood Grande II Imtiaz</Link>

     


<Link style={{padding: "10px"}} to="/landscaping-service-act-one-act-two-dubai">Landscaping Service in Act One Act Two Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-address-opera-dubai">Landscaping Service in Address Opera Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-bel-air-dubai">Landscaping Service in Bel Air Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-bliss-1-2-dubai">Landscaping Service in Bliss 1 & 2 Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-burj-crown-dubai">Landscaping Service in Burj Crown Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-emaar-oasis-dubai">Landscaping Service in Emaar Oasis Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-golf-acres-dubai-south">Landscaping Service in Golf Acres Dubai South</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-golf-dale-dubai-south">Landscaping Service in Golf Dale Dubai South</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-golf-edge-dubai-south">Landscaping Service in Golf Edge Dubai South</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-golf-lane-dubai-south">Landscaping Service in Golf Lane Dubai South</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-golf-links-dubai-south">Landscaping Service in Golf Links Dubai South</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-golf-links-1-2-dubai-south">Landscaping Service in Golf Links 1 & 2 Dubai South</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-green-ridge-dubai-south">Landscaping Service in Green Ridge Dubai South</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-greens-point-dubai-south">Landscaping Service in Greens Point Dubai South</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-green-ville-dubai-south">Landscaping Service in Green Ville Dubai South</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-green-way-1-2-dubai-south">Landscaping Service in Green Way 1 & 2 Dubai South</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-luxur-tower-imtiaz">Landscaping Service in Luxur Tower Imtiaz</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-majara-dm-dubai">Landscaping Service in Majara DM Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-maple-1-2-3-dubai">Landscaping Service in Maple 1 2 3 Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-sirda-1-2-3-dubai">Landscaping Service in Sirda 1 2 3 Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-park-residences-dubai">Landscaping Service in Park Residences Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-pearl-house-imtiaz">Landscaping Service in Pearl House Imtiaz</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-r3-ruba-dubai">Landscaping Service in R3 Ruba Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-raya-1-dubai">Landscaping Service in Raya 1 Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-reportage-village-dubai">Landscaping Service in Reportage Village Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-silver-spring-trump-estate-2">Landscaping Service in Silver Spring Trump Estate 2</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-silver-springs-dubai">Landscaping Service in Silver Springs Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-sobha-creek-vistas-grande">Landscaping Service in Sobha Creek Vistas Grande</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-south-bay-dubai-south">Landscaping Service in South Bay Dubai South</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-the-valley-dubai">Landscaping Service in The Valley Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-veneto-1-dubai">Landscaping Service in Veneto 1 Dubai</Link>
<Link style={{padding: "10px"}} to="/landscaping-service-westwood-grande-ii-imtiaz">Landscaping Service in Westwood Grande II Imtiaz</Link>














<Link style={{padding: "10px"}} to="/swimming-pool-maintenance/palm-jumeirah">Swimming Pool Maintenance in Palm Jumeirah</Link>
<Link style={{padding: "10px"}} to="/swimming-pool-maintenance/jumeirah-islands">Swimming Pool Maintenance in Jumeirah Islands</Link>
<Link style={{padding: "10px"}} to="/swimming-pool-maintenance/jumeirah-park">Swimming Pool Maintenance in Jumeirah Park</Link>
<Link style={{padding: "10px"}} to="/swimming-pool-maintenance/dubai-hills-estate">Swimming Pool Maintenance in Dubai Hills Estate</Link>
<Link style={{padding: "10px"}} to="/swimming-pool-maintenance/arabian-ranches-2">Swimming Pool Maintenance in Arabian Ranches 2</Link>
<Link style={{padding: "10px"}} to="/swimming-pool-maintenance/damac-hills">Swimming Pool Maintenance in Damac Hills</Link>
<Link style={{padding: "10px"}} to="/swimming-pool-maintenance/damac-lagoons">Swimming Pool Maintenance in Damac Lagoons</Link>
<Link style={{padding: "10px"}} to="/swimming-pool-maintenance/sustainable-city">Swimming Pool Maintenance in Sustainable City</Link>
<Link style={{padding: "10px"}} to="/swimming-pool-maintenance/al-barari">Swimming Pool Maintenance in Al Barari</Link>
<Link style={{padding: "10px"}} to="/swimming-pool-maintenance/jumeirah-golf-estates">Swimming Pool Maintenance in Jumeirah Golf Estates</Link>
<Link style={{padding: "10px"}} to="/swimming-pool-maintenance/tilal-al-ghaf">Swimming Pool Maintenance in Tilal Al Ghaf</Link>
<Link style={{padding: "10px"}} to="/indoor-plants/palm-jumeirah">Indoor Plants Service in Palm Jumeirah</Link>
<Link style={{padding: "10px"}} to="/indoor-plants/jumeirah-islands">Indoor Plants Service in Jumeirah Islands</Link>
<Link style={{padding: "10px"}} to="/indoor-plants/jumeirah-park">Indoor Plants Service in Jumeirah Park</Link>
<Link style={{padding: "10px"}} to="/indoor-plants/dubai-hills-estate">Indoor Plants Service in Dubai Hills Estate</Link>
<Link style={{padding: "10px"}} to="/indoor-plants/arabian-ranches-2">Indoor Plants Service in Arabian Ranches 2</Link>
<Link style={{padding: "10px"}} to="/indoor-plants/damac-hills">Indoor Plants Service in Damac Hills</Link>
<Link style={{padding: "10px"}} to="/indoor-plants/damac-lagoons">Indoor Plants Service in Damac Lagoons</Link>
<Link style={{padding: "10px"}} to="/indoor-plants/sustainable-city">Indoor Plants Service in Sustainable City</Link>
<Link style={{padding: "10px"}} to="/indoor-plants/al-barari">Indoor Plants Service in Al Barari</Link>
<Link style={{padding: "10px"}} to="/indoor-plants/jumeirah-golf-estates">Indoor Plants Service in Jumeirah Golf Estates</Link>
<Link style={{padding: "10px"}} to="/indoor-plants/tilal-al-ghaf">Indoor Plants Service in Tilal Al Ghaf</Link>
<Link style={{padding: "10px"}} to="/landscaping/jumeirah-islands">Garden Landscaping Service in Jumeirah Islands</Link>
<Link style={{padding: "10px"}} to="/landscaping/jumeirah-park">Garden Landscaping Service in Jumeirah Park</Link>
<Link style={{padding: "10px"}} to="/landscaping/damac-hills">Garden Landscaping Service in Damac Hills</Link>
<Link style={{padding: "10px"}} to="/landscaping/damac-lagoons">Garden Landscaping Service in Damac Lagoons</Link>
<Link style={{padding: "10px"}} to="/landscaping/sustainable-city">Garden Landscaping Service in Sustainable City</Link>
<Link style={{padding: "10px"}} to="/landscaping/al-barari">Garden Landscaping Service in Al Barari</Link>
<Link style={{padding: "10px"}} to="/landscaping/tilal-al-ghaf">Garden Landscaping Service in Tilal Al Ghaf</Link>
<Link style={{padding: "10px"}} to="/villa-maintenance/palm-jumeirah">Villa Maintenance Contract in Palm Jumeirah</Link>
<Link style={{padding: "10px"}} to="/villa-maintenance/jumeirah-islands">Villa Maintenance Contract in Jumeirah Islands</Link>
<Link style={{padding: "10px"}} to="/villa-maintenance/jumeirah-park">Villa Maintenance Contract in Jumeirah Park</Link>
<Link style={{padding: "10px"}} to="/villa-maintenance/arabian-ranches-2">Villa Maintenance Contract in Arabian Ranches 2</Link>
<Link style={{padding: "10px"}} to="/villa-maintenance/damac-hills">Villa Maintenance Contract in Damac Hills</Link>
<Link style={{padding: "10px"}} to="/villa-maintenance/damac-lagoons">Villa Maintenance Contract in Damac Lagoons</Link>
<Link style={{padding: "10px"}} to="/villa-maintenance/sustainable-city">Villa Maintenance Contract in Sustainable City</Link>
<Link style={{padding: "10px"}} to="/villa-maintenance/al-barari">Villa Maintenance Contract in Al Barari</Link>
<Link style={{padding: "10px"}} to="/villa-maintenance/jumeirah-golf-estates">Villa Maintenance Contract in Jumeirah Golf Estates</Link>
<Link style={{padding: "10px"}} to="/villa-maintenance/tilal-al-ghaf">Villa Maintenance Contract in Tilal Al Ghaf</Link>
<Link style={{padding: "10px"}} to="/pest-control/palm-jumeirah">Pest Control Service in Palm Jumeirah</Link>
<Link style={{padding: "10px"}} to="/pest-control/jumeirah-islands">Pest Control Service in Jumeirah Islands</Link>
<Link style={{padding: "10px"}} to="/pest-control/jumeirah-park">Pest Control Service in Jumeirah Park</Link>
<Link style={{padding: "10px"}} to="/pest-control/dubai-hills-estate">Pest Control Service in Dubai Hills Estate</Link>
<Link style={{padding: "10px"}} to="/pest-control/arabian-ranches-2">Pest Control Service in Arabian Ranches 2</Link>
<Link style={{padding: "10px"}} to="/pest-control/damac-hills">Pest Control Service in Damac Hills</Link>
<Link style={{padding: "10px"}} to="/pest-control/damac-lagoons">Pest Control Service in Damac Lagoons</Link>
<Link style={{padding: "10px"}} to="/pest-control/sustainable-city">Pest Control Service in Sustainable City</Link>
<Link style={{padding: "10px"}} to="/pest-control/al-barari">Pest Control Service in Al Barari</Link>
<Link style={{padding: "10px"}} to="/pest-control/jumeirah-golf-estates">Pest Control Service in Jumeirah Golf Estates</Link>
<Link style={{padding: "10px"}} to="/pest-control/tilal-al-ghaf">Pest Control Service in Tilal Al Ghaf</Link>
<Link style={{padding: "10px"}} to="/garden-shop/jumeirah-islands">Garden Shop in Jumeirah Islands</Link>
<Link style={{padding: "10px"}} to="/garden-shop/jumeirah-park">Garden Shop in Jumeirah Park</Link>
<Link style={{padding: "10px"}} to="/garden-shop/dubai-hills-estate">Garden Shop in Dubai Hills Estate</Link>
<Link style={{padding: "10px"}} to="/garden-shop/arabian-ranches-2">Garden Shop in Arabian Ranches 2</Link>
<Link style={{padding: "10px"}} to="/garden-shop/damac-hills">Garden Shop in Damac Hills</Link>
<Link style={{padding: "10px"}} to="/garden-shop/damac-lagoons">Garden Shop in Damac Lagoons</Link>
<Link style={{padding: "10px"}} to="/garden-shop/sustainable-city">Garden Shop in Sustainable City</Link>
<Link style={{padding: "10px"}} to="/garden-shop/al-barari">Garden Shop in Al Barari</Link>
<Link style={{padding: "10px"}} to="/garden-shop/tilal-al-ghaf">Garden Shop in Tilal Al Ghaf</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale/jumeirah-islands">Plant Wholesale in Jumeirah Islands</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale/jumeirah-park">Plant Wholesale in Jumeirah Park</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale/dubai-hills-estate">Plant Wholesale in Dubai Hills Estate</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale/arabian-ranches-2">Plant Wholesale in Arabian Ranches 2</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale/damac-hills">Plant Wholesale in Damac Hills</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale/damac-lagoons">Plant Wholesale in Damac Lagoons</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale/sustainable-city">Plant Wholesale in Sustainable City</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale/al-barari">Plant Wholesale in Al Barari</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale/jumeirah-golf-estates">Plant Wholesale in Jumeirah Golf Estates</Link>
<Link style={{padding: "10px"}} to="/plant-wholesale/tilal-al-ghaf">Plant Wholesale in Tilal Al Ghaf</Link>
<Link style={{padding: "10px"}} to="/commercial-landscaping/palm-jumeirah">Commercial Landscaping in Palm Jumeirah</Link>
<Link style={{padding: "10px"}} to="/commercial-landscaping/jumeirah-islands">Commercial Landscaping in Jumeirah Islands</Link>
<Link style={{padding: "10px"}} to="/commercial-landscaping/jumeirah-park">Commercial Landscaping in Jumeirah Park</Link>
<Link style={{padding: "10px"}} to="/commercial-landscaping/dubai-hills-estate">Commercial Landscaping in Dubai Hills Estate</Link>
<Link style={{padding: "10px"}} to="/commercial-landscaping/arabian-ranches-2">Commercial Landscaping in Arabian Ranches 2</Link>
<Link style={{padding: "10px"}} to="/commercial-landscaping/damac-hills">Commercial Landscaping in Damac Hills</Link>
<Link style={{padding: "10px"}} to="/commercial-landscaping/damac-lagoons">Commercial Landscaping in Damac Lagoons</Link>
<Link style={{padding: "10px"}} to="/commercial-landscaping/sustainable-city">Commercial Landscaping in Sustainable City</Link>
<Link style={{padding: "10px"}} to="/commercial-landscaping/al-barari">Commercial Landscaping in Al Barari</Link>
<Link style={{padding: "10px"}} to="/commercial-landscaping/jumeirah-golf-estates">Commercial Landscaping in Jumeirah Golf Estates</Link>
<Link style={{padding: "10px"}} to="/commercial-landscaping/tilal-al-ghaf">Commercial Landscaping in Tilal Al Ghaf</Link>
<Link style={{padding: "10px"}} to="/annual-maintenance/jumeirah-islands">Annual Maintenance Contract in Jumeirah Islands</Link>
<Link style={{padding: "10px"}} to="/annual-maintenance/jumeirah-park">Annual Maintenance Contract in Jumeirah Park</Link>
<Link style={{padding: "10px"}} to="/annual-maintenance/dubai-hills-estate">Annual Maintenance Contract in Dubai Hills Estate</Link>
<Link style={{padding: "10px"}} to="/annual-maintenance/arabian-ranches-2">Annual Maintenance Contract in Arabian Ranches 2</Link>
<Link style={{padding: "10px"}} to="/annual-maintenance/damac-hills">Annual Maintenance Contract in Damac Hills</Link>
<Link style={{padding: "10px"}} to="/annual-maintenance/damac-lagoons">Annual Maintenance Contract in Damac Hills</Link>
<Link style={{padding: "10px"}} to="/annual-maintenance/sustainable-city">Annual Maintenance Contract in Sustainable City</Link>
<Link style={{padding: "10px"}} to="/annual-maintenance/al-barari">Annual Maintenance Contract in Al Barari</Link>
<Link style={{padding: "10px"}} to="/annual-maintenance/jumeirah-golf-estates">Annual Maintenance Contract in Jumeirah Golf Estates</Link>
<Link style={{padding: "10px"}} to="/annual-maintenance/tilal-al-ghaf">Annual Maintenance Contract in Tilal Al Ghaf</Link>


   
  </p>

            </div>
            </div>
            </div>

 */}


<section className="modern-about-section">
  <div className="container">
    
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14456.00332046206!2d55.2340126!3d25.067961!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6f000941baa7%3A0x4a382dcb4df6f658!2sGarden%20Oasis%20Landscaping!5e0!3m2!1sen!2s!4v1716614270886!5m2!1sen!2s" width="100%" height="450" style={{border:0}}  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

      </div>
            </section>

              
              {/* End .blog-posts */}
            </main>
            
            {/* End .footer */}
          </div>
          <button id="scroll-top" title="Back to Top">
            <i className="icon-arrow-up" />
          </button>
          {/* Mobile Menu */}
          
          {/* <div className="container newsletter-popup-container mfp-hide" id="newsletter-popup-form">
            <div className="row justify-content-center">
              <div className="col-10">
                <div className="row no-gutters bg-white newsletter-popup-content">
                  <div className="col-xl-3-5col col-lg-7 banner-content-wrap">
                    <div className="banner-content text-center">
                      <img src="assets/images/popup/newsletter/logo.png" className="logo" alt="logo" width={60} height={15} />
                      <h2 className="banner-title">get
                        <span>25</span>
                        <mark>%</mark> off</h2>
                      <p>Subscribe to the Molla eCommerce newsletter to receive timely updates from your favorite products.</p>
                      <form action="#">
                        <div className="input-group input-group-round">
                          <input type="email" className="form-control form-control-white" placeholder="Your Email Address" aria-label="Email Adress" required />
                          <div className="input-group-append">
                            <button className="btn" type="submit">
                              <span>go</span>
                            </button>
                          </div>
                        </div>
                      </form>
                        <div className="custom-control custom-checkbox">
                        <input type="checkbox" className="custom-control-input" id="register-policy-2" required />
                        <label className="custom-control-label" htmlFor="register-policy-2">Do not show this popup again</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-2-5col col-lg-5 ">
                    <img src="assets/images/popup/newsletter/img-1.jpg" className="newsletter-img" alt="newsletter" width={700} height={400} />
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        )
    
}

export default Home;